import i, { useMemo as H, forwardRef as oe, useCallback as V, useState as tt } from "react";
var rt = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function a() {
      for (var n = "", l = 0; l < arguments.length; l++) {
        var s = arguments[l];
        s && (n = o(n, r(s)));
      }
      return n;
    }
    function r(n) {
      if (typeof n == "string" || typeof n == "number")
        return n;
      if (typeof n != "object")
        return "";
      if (Array.isArray(n))
        return a.apply(null, n);
      if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]"))
        return n.toString();
      var l = "";
      for (var s in n)
        t.call(n, s) && n[s] && (l = o(l, s));
      return l;
    }
    function o(n, l) {
      return l ? n ? n + " " + l : n + l : n;
    }
    e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
  })();
})(rt);
const b = rt.exports;
var je = "ButtonBase_3_1_3_1ijualg0", Ne = { medium: "ButtonBase_3_1_3_1ijualg1", small: "ButtonBase_3_1_3_1ijualg2", tiny: "ButtonBase_3_1_3_1ijualg3" }, pt = { medium: "ButtonBase_3_1_3_1ijualg10", small: "ButtonBase_3_1_3_1ijualg11", tiny: "ButtonBase_3_1_3_1ijualg12" }, Be = { medium: "ButtonBase_3_1_3_1ijualgd", small: "ButtonBase_3_1_3_1ijualge", tiny: "ButtonBase_3_1_3_1ijualgf" }, ft = { medium: "ButtonBase_3_1_3_1ijualgx", small: "ButtonBase_3_1_3_1ijualgy", tiny: "ButtonBase_3_1_3_1ijualgz" }, we = { medium: "ButtonBase_3_1_3_1ijualgg", small: "ButtonBase_3_1_3_1ijualgh", tiny: "ButtonBase_3_1_3_1ijualgi" }, Te = { primary: "ButtonBase_3_1_3_1ijualgp", secondary: "ButtonBase_3_1_3_1ijualgq", danger: "ButtonBase_3_1_3_1ijualgr", plain: "ButtonBase_3_1_3_1ijualgs", mccred: "ButtonBase_3_1_3_1ijualgt" }, ze = "ButtonBase_3_1_3_1ijualgo", Fe = { medium: "ButtonBase_3_1_3_1ijualg7", small: "ButtonBase_3_1_3_1ijualg8", tiny: "ButtonBase_3_1_3_1ijualg9" }, Ce = { medium: "ButtonBase_3_1_3_1ijualga", small: "ButtonBase_3_1_3_1ijualgb", tiny: "ButtonBase_3_1_3_1ijualgc" }, te = { medium: "ButtonBase_3_1_3_1ijualg4", small: "ButtonBase_3_1_3_1ijualg5", tiny: "ButtonBase_3_1_3_1ijualg6" }, re = "ButtonBase_3_1_3_1ijualg14", vt = "ButtonBase_3_1_3_1ijualg13", _t = { medium: "ButtonBase_3_1_3_1ijualgu", small: "ButtonBase_3_1_3_1ijualgv", tiny: "ButtonBase_3_1_3_1ijualgw" }, Oe = { primary: "ButtonBase_3_1_3_1ijualgj", secondary: "ButtonBase_3_1_3_1ijualgk", danger: "ButtonBase_3_1_3_1ijualgl", plain: "ButtonBase_3_1_3_1ijualgm", mccred: "ButtonBase_3_1_3_1ijualgn" }, at = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Ie = i.createContext && i.createContext(at), $ = globalThis && globalThis.__assign || function() {
  return $ = Object.assign || function(e) {
    for (var t, a = 1, r = arguments.length; a < r; a++) {
      t = arguments[a];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, $.apply(this, arguments);
}, dt = globalThis && globalThis.__rest || function(e, t) {
  var a = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (a[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (a[r[o]] = e[r[o]]);
  return a;
};
function it(e) {
  return e && e.map(function(t, a) {
    return i.createElement(t.tag, $({
      key: a
    }, t.attr), it(t.child));
  });
}
function W(e) {
  return function(t) {
    return i.createElement(gt, $({
      attr: $({}, e.attr)
    }, t), it(e.child));
  };
}
function gt(e) {
  var t = function(a) {
    var r = e.attr, o = e.size, n = e.title, l = dt(e, ["attr", "size", "title"]), s = o || a.size || "1em", u;
    return a.className && (u = a.className), e.className && (u = (u ? u + " " : "") + e.className), i.createElement("svg", $({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, a.attr, r, l, {
      className: u,
      style: $($({
        color: e.color || a.color
      }, a.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), n && i.createElement("title", null, n), e.children);
  };
  return Ie !== void 0 ? i.createElement(Ie.Consumer, null, function(a) {
    return t(a);
  }) : t(at);
}
function bt(e) {
  return W({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2z" } }, { tag: "path", attr: { d: "M13 16h-2v2h2zM13 10h-2v5h2z" } }] })(e);
}
function ht(e) {
  return W({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" } }] })(e);
}
function yt(e) {
  return W({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" } }] })(e);
}
function St(e) {
  return W({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" } }] })(e);
}
function kt(e) {
  return W({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" } }] })(e);
}
function Pt(e) {
  return W({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" } }] })(e);
}
function xt(e) {
  return W({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" } }] })(e);
}
var Et = "Spinner_3_1_3_uldb1k0", jt = { white: "Spinner_3_1_3_uldb1k1", primary: "Spinner_3_1_3_uldb1k2" }, Nt = { medium: "Spinner_3_1_3_uldb1k3", small: "Spinner_3_1_3_uldb1k4", tiny: "Spinner_3_1_3_uldb1k5" };
const K = ({ color: e = "white", size: t = "medium", testId: a }) => /* @__PURE__ */ i.createElement("div", { className: b(Et, Nt[t]), "data-testid": a }, /* @__PURE__ */ i.createElement("svg", { version: "1.1", id: "spinner", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 50" }, /* @__PURE__ */ i.createElement(
  "path",
  {
    className: jt[e],
    d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
  },
  /* @__PURE__ */ i.createElement(
    "animateTransform",
    {
      attributeType: "xml",
      attributeName: "transform",
      type: "rotate",
      from: "0 25 25",
      to: "360 25 25",
      dur: "0.6s",
      repeatCount: "indefinite"
    }
  )
))), De = ({
  chevron: e,
  iconLeft: t,
  iconRight: a,
  hasNoIcon: r,
  isLoading: o,
  spinnerColor: n,
  size: l,
  children: s
}) => /* @__PURE__ */ i.createElement(i.Fragment, null, e === "left" && /* @__PURE__ */ i.createElement(i.Fragment, null, o ? /* @__PURE__ */ i.createElement("div", { className: pt[l] }, /* @__PURE__ */ i.createElement(K, { color: n, size: l })) : /* @__PURE__ */ i.createElement("span", { className: b(re, te[l]) }, /* @__PURE__ */ i.createElement(yt, null))), t && /* @__PURE__ */ i.createElement(i.Fragment, null, o ? /* @__PURE__ */ i.createElement(K, { color: n, size: l }) : /* @__PURE__ */ i.createElement("span", { className: b(re, te[l]) }, t)), r && o && /* @__PURE__ */ i.createElement("div", { className: _t[l] }, /* @__PURE__ */ i.createElement(K, { color: n, size: l })), /* @__PURE__ */ i.createElement("span", { className: vt }, s), a && /* @__PURE__ */ i.createElement(i.Fragment, null, o ? /* @__PURE__ */ i.createElement(K, { color: n, size: l }) : /* @__PURE__ */ i.createElement("span", { className: b(re, te[l]) }, a)), e === "right" && /* @__PURE__ */ i.createElement(i.Fragment, null, o ? /* @__PURE__ */ i.createElement("div", { className: ft[l] }, /* @__PURE__ */ i.createElement(K, { color: n, size: l })) : /* @__PURE__ */ i.createElement("span", { className: b(re, te[l]) }, /* @__PURE__ */ i.createElement(St, null)))), xe = (e) => {
  const {
    as: t = "button",
    variant: a = "primary",
    size: r = "medium",
    chevron: o = "none",
    iconLeft: n,
    iconRight: l,
    fullWidth: s = !1,
    children: u,
    isLoading: f = !1,
    disabled: m = !1,
    className: d,
    testId: g,
    ...y
  } = e, O = a === "secondary" || a === "plain" ? "primary" : "white", B = !n && !l && o === "none";
  return /* @__PURE__ */ i.createElement(
    t,
    {
      className: b(d, je, Ne[r], Oe[a], {
        [ze]: s,
        [Te[a]]: m || f,
        [Fe[r]]: n,
        [Ce[r]]: l,
        [Be[r]]: o === "left",
        [we[r]]: o === "right"
      }),
      "data-testid": g,
      disabled: m || f,
      ...y
    },
    /* @__PURE__ */ i.createElement(
      De,
      {
        chevron: o,
        iconLeft: n,
        iconRight: l,
        hasNoIcon: B,
        isLoading: f,
        spinnerColor: O,
        size: r
      },
      u
    )
  );
}, xi = ({
  variant: e = "primary",
  size: t = "medium",
  chevron: a = "none",
  iconLeft: r,
  iconRight: o,
  fullWidth: n = !1,
  children: l,
  isLoading: s = !1,
  disabled: u = !1,
  className: f,
  testId: m,
  ...d
}) => {
  const g = e === "secondary" || e === "plain" ? "primary" : "white", y = !r && !o && a === "none";
  return /* @__PURE__ */ i.createElement(
    "a",
    {
      className: b(f, je, Ne[t], Oe[e], {
        [ze]: n,
        [Te[e]]: u,
        [Fe[t]]: r,
        [Ce[t]]: o,
        [Be[t]]: a === "left",
        [we[t]]: a === "right"
      }),
      "data-testid": m,
      ...d
    },
    /* @__PURE__ */ i.createElement(
      De,
      {
        chevron: a,
        iconLeft: r,
        iconRight: o,
        hasNoIcon: y,
        isLoading: s,
        spinnerColor: g,
        size: t
      },
      l
    )
  );
};
var G = { exports: {} }, de = { exports: {} }, w = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $e;
function Bt() {
  if ($e)
    return w;
  $e = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, a = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, n = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, O = e ? Symbol.for("react.lazy") : 60116, B = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, L = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
  function z(v) {
    if (typeof v == "object" && v !== null) {
      var Y = v.$$typeof;
      switch (Y) {
        case t:
          switch (v = v.type, v) {
            case u:
            case f:
            case r:
            case n:
            case o:
            case d:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case s:
                case m:
                case O:
                case y:
                case l:
                  return v;
                default:
                  return Y;
              }
          }
        case a:
          return Y;
      }
    }
  }
  function R(v) {
    return z(v) === f;
  }
  return w.AsyncMode = u, w.ConcurrentMode = f, w.ContextConsumer = s, w.ContextProvider = l, w.Element = t, w.ForwardRef = m, w.Fragment = r, w.Lazy = O, w.Memo = y, w.Portal = a, w.Profiler = n, w.StrictMode = o, w.Suspense = d, w.isAsyncMode = function(v) {
    return R(v) || z(v) === u;
  }, w.isConcurrentMode = R, w.isContextConsumer = function(v) {
    return z(v) === s;
  }, w.isContextProvider = function(v) {
    return z(v) === l;
  }, w.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === t;
  }, w.isForwardRef = function(v) {
    return z(v) === m;
  }, w.isFragment = function(v) {
    return z(v) === r;
  }, w.isLazy = function(v) {
    return z(v) === O;
  }, w.isMemo = function(v) {
    return z(v) === y;
  }, w.isPortal = function(v) {
    return z(v) === a;
  }, w.isProfiler = function(v) {
    return z(v) === n;
  }, w.isStrictMode = function(v) {
    return z(v) === o;
  }, w.isSuspense = function(v) {
    return z(v) === d;
  }, w.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === r || v === f || v === n || v === o || v === d || v === g || typeof v == "object" && v !== null && (v.$$typeof === O || v.$$typeof === y || v.$$typeof === l || v.$$typeof === s || v.$$typeof === m || v.$$typeof === C || v.$$typeof === L || v.$$typeof === D || v.$$typeof === B);
  }, w.typeOf = z, w;
}
var T = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ye;
function wt() {
  return Ye || (Ye = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, a = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, n = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, O = e ? Symbol.for("react.lazy") : 60116, B = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, L = e ? Symbol.for("react.responder") : 60118, D = e ? Symbol.for("react.scope") : 60119;
    function z(p) {
      return typeof p == "string" || typeof p == "function" || p === r || p === f || p === n || p === o || p === d || p === g || typeof p == "object" && p !== null && (p.$$typeof === O || p.$$typeof === y || p.$$typeof === l || p.$$typeof === s || p.$$typeof === m || p.$$typeof === C || p.$$typeof === L || p.$$typeof === D || p.$$typeof === B);
    }
    function R(p) {
      if (typeof p == "object" && p !== null) {
        var I = p.$$typeof;
        switch (I) {
          case t:
            var ee = p.type;
            switch (ee) {
              case u:
              case f:
              case r:
              case n:
              case o:
              case d:
                return ee;
              default:
                var Ae = ee && ee.$$typeof;
                switch (Ae) {
                  case s:
                  case m:
                  case O:
                  case y:
                  case l:
                    return Ae;
                  default:
                    return I;
                }
            }
          case a:
            return I;
        }
      }
    }
    var v = u, Y = f, se = s, ce = l, ue = t, me = m, Q = r, pe = O, fe = y, U = a, ve = n, A = o, q = d, Z = !1;
    function _e(p) {
      return Z || (Z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), c(p) || R(p) === u;
    }
    function c(p) {
      return R(p) === f;
    }
    function _(p) {
      return R(p) === s;
    }
    function x(p) {
      return R(p) === l;
    }
    function k(p) {
      return typeof p == "object" && p !== null && p.$$typeof === t;
    }
    function h(p) {
      return R(p) === m;
    }
    function E(p) {
      return R(p) === r;
    }
    function S(p) {
      return R(p) === O;
    }
    function P(p) {
      return R(p) === y;
    }
    function j(p) {
      return R(p) === a;
    }
    function F(p) {
      return R(p) === n;
    }
    function N(p) {
      return R(p) === o;
    }
    function M(p) {
      return R(p) === d;
    }
    T.AsyncMode = v, T.ConcurrentMode = Y, T.ContextConsumer = se, T.ContextProvider = ce, T.Element = ue, T.ForwardRef = me, T.Fragment = Q, T.Lazy = pe, T.Memo = fe, T.Portal = U, T.Profiler = ve, T.StrictMode = A, T.Suspense = q, T.isAsyncMode = _e, T.isConcurrentMode = c, T.isContextConsumer = _, T.isContextProvider = x, T.isElement = k, T.isForwardRef = h, T.isFragment = E, T.isLazy = S, T.isMemo = P, T.isPortal = j, T.isProfiler = F, T.isStrictMode = N, T.isSuspense = M, T.isValidElementType = z, T.typeOf = R;
  }()), T;
}
var qe;
function ot() {
  return qe || (qe = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = Bt() : e.exports = wt();
  }(de)), de.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ge, We;
function Tt() {
  if (We)
    return ge;
  We = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
  function r(n) {
    if (n == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(n);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var n = new String("abc");
      if (n[5] = "de", Object.getOwnPropertyNames(n)[0] === "5")
        return !1;
      for (var l = {}, s = 0; s < 10; s++)
        l["_" + String.fromCharCode(s)] = s;
      var u = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        f[m] = m;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ge = o() ? Object.assign : function(n, l) {
    for (var s, u = r(n), f, m = 1; m < arguments.length; m++) {
      s = Object(arguments[m]);
      for (var d in s)
        t.call(s, d) && (u[d] = s[d]);
      if (e) {
        f = e(s);
        for (var g = 0; g < f.length; g++)
          a.call(s, f[g]) && (u[f[g]] = s[f[g]]);
      }
    }
    return u;
  }, ge;
}
var be, Ue;
function Le() {
  if (Ue)
    return be;
  Ue = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return be = e, be;
}
var he, Je;
function nt() {
  return Je || (Je = 1, he = Function.call.bind(Object.prototype.hasOwnProperty)), he;
}
var ye, Xe;
function zt() {
  if (Xe)
    return ye;
  Xe = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Le(), a = {}, r = nt();
    e = function(n) {
      var l = "Warning: " + n;
      typeof console != "undefined" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function o(n, l, s, u, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var m in n)
        if (r(n, m)) {
          var d;
          try {
            if (typeof n[m] != "function") {
              var g = Error(
                (u || "React class") + ": " + s + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            d = n[m](l, m, u, s, null, t);
          } catch (O) {
            d = O;
          }
          if (d && !(d instanceof Error) && e(
            (u || "React class") + ": type specification of " + s + " `" + m + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in a)) {
            a[d.message] = !0;
            var y = f ? f() : "";
            e(
              "Failed " + s + " type: " + d.message + (y != null ? y : "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (a = {});
  }, ye = o, ye;
}
var Se, Ke;
function Ft() {
  if (Ke)
    return Se;
  Ke = 1;
  var e = ot(), t = Tt(), a = Le(), r = nt(), o = zt(), n = function() {
  };
  process.env.NODE_ENV !== "production" && (n = function(s) {
    var u = "Warning: " + s;
    typeof console != "undefined" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return Se = function(s, u) {
    var f = typeof Symbol == "function" && Symbol.iterator, m = "@@iterator";
    function d(c) {
      var _ = c && (f && c[f] || c[m]);
      if (typeof _ == "function")
        return _;
    }
    var g = "<<anonymous>>", y = {
      array: L("array"),
      bigint: L("bigint"),
      bool: L("boolean"),
      func: L("function"),
      number: L("number"),
      object: L("object"),
      string: L("string"),
      symbol: L("symbol"),
      any: D(),
      arrayOf: z,
      element: R(),
      elementType: v(),
      instanceOf: Y,
      node: me(),
      objectOf: ce,
      oneOf: se,
      oneOfType: ue,
      shape: pe,
      exact: fe
    };
    function O(c, _) {
      return c === _ ? c !== 0 || 1 / c === 1 / _ : c !== c && _ !== _;
    }
    function B(c, _) {
      this.message = c, this.data = _ && typeof _ == "object" ? _ : {}, this.stack = "";
    }
    B.prototype = Error.prototype;
    function C(c) {
      if (process.env.NODE_ENV !== "production")
        var _ = {}, x = 0;
      function k(E, S, P, j, F, N, M) {
        if (j = j || g, N = N || P, M !== a) {
          if (u) {
            var p = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw p.name = "Invariant Violation", p;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var I = j + ":" + P;
            !_[I] && x < 3 && (n(
              "You are manually calling a React.PropTypes validation function for the `" + N + "` prop on `" + j + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), _[I] = !0, x++);
          }
        }
        return S[P] == null ? E ? S[P] === null ? new B("The " + F + " `" + N + "` is marked as required " + ("in `" + j + "`, but its value is `null`.")) : new B("The " + F + " `" + N + "` is marked as required in " + ("`" + j + "`, but its value is `undefined`.")) : null : c(S, P, j, F, N);
      }
      var h = k.bind(null, !1);
      return h.isRequired = k.bind(null, !0), h;
    }
    function L(c) {
      function _(x, k, h, E, S, P) {
        var j = x[k], F = A(j);
        if (F !== c) {
          var N = q(j);
          return new B(
            "Invalid " + E + " `" + S + "` of type " + ("`" + N + "` supplied to `" + h + "`, expected ") + ("`" + c + "`."),
            { expectedType: c }
          );
        }
        return null;
      }
      return C(_);
    }
    function D() {
      return C(l);
    }
    function z(c) {
      function _(x, k, h, E, S) {
        if (typeof c != "function")
          return new B("Property `" + S + "` of component `" + h + "` has invalid PropType notation inside arrayOf.");
        var P = x[k];
        if (!Array.isArray(P)) {
          var j = A(P);
          return new B("Invalid " + E + " `" + S + "` of type " + ("`" + j + "` supplied to `" + h + "`, expected an array."));
        }
        for (var F = 0; F < P.length; F++) {
          var N = c(P, F, h, E, S + "[" + F + "]", a);
          if (N instanceof Error)
            return N;
        }
        return null;
      }
      return C(_);
    }
    function R() {
      function c(_, x, k, h, E) {
        var S = _[x];
        if (!s(S)) {
          var P = A(S);
          return new B("Invalid " + h + " `" + E + "` of type " + ("`" + P + "` supplied to `" + k + "`, expected a single ReactElement."));
        }
        return null;
      }
      return C(c);
    }
    function v() {
      function c(_, x, k, h, E) {
        var S = _[x];
        if (!e.isValidElementType(S)) {
          var P = A(S);
          return new B("Invalid " + h + " `" + E + "` of type " + ("`" + P + "` supplied to `" + k + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return C(c);
    }
    function Y(c) {
      function _(x, k, h, E, S) {
        if (!(x[k] instanceof c)) {
          var P = c.name || g, j = _e(x[k]);
          return new B("Invalid " + E + " `" + S + "` of type " + ("`" + j + "` supplied to `" + h + "`, expected ") + ("instance of `" + P + "`."));
        }
        return null;
      }
      return C(_);
    }
    function se(c) {
      if (!Array.isArray(c))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? n(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : n("Invalid argument supplied to oneOf, expected an array.")), l;
      function _(x, k, h, E, S) {
        for (var P = x[k], j = 0; j < c.length; j++)
          if (O(P, c[j]))
            return null;
        var F = JSON.stringify(c, function(M, p) {
          var I = q(p);
          return I === "symbol" ? String(p) : p;
        });
        return new B("Invalid " + E + " `" + S + "` of value `" + String(P) + "` " + ("supplied to `" + h + "`, expected one of " + F + "."));
      }
      return C(_);
    }
    function ce(c) {
      function _(x, k, h, E, S) {
        if (typeof c != "function")
          return new B("Property `" + S + "` of component `" + h + "` has invalid PropType notation inside objectOf.");
        var P = x[k], j = A(P);
        if (j !== "object")
          return new B("Invalid " + E + " `" + S + "` of type " + ("`" + j + "` supplied to `" + h + "`, expected an object."));
        for (var F in P)
          if (r(P, F)) {
            var N = c(P, F, h, E, S + "." + F, a);
            if (N instanceof Error)
              return N;
          }
        return null;
      }
      return C(_);
    }
    function ue(c) {
      if (!Array.isArray(c))
        return process.env.NODE_ENV !== "production" && n("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var _ = 0; _ < c.length; _++) {
        var x = c[_];
        if (typeof x != "function")
          return n(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Z(x) + " at index " + _ + "."
          ), l;
      }
      function k(h, E, S, P, j) {
        for (var F = [], N = 0; N < c.length; N++) {
          var M = c[N], p = M(h, E, S, P, j, a);
          if (p == null)
            return null;
          p.data && r(p.data, "expectedType") && F.push(p.data.expectedType);
        }
        var I = F.length > 0 ? ", expected one of type [" + F.join(", ") + "]" : "";
        return new B("Invalid " + P + " `" + j + "` supplied to " + ("`" + S + "`" + I + "."));
      }
      return C(k);
    }
    function me() {
      function c(_, x, k, h, E) {
        return U(_[x]) ? null : new B("Invalid " + h + " `" + E + "` supplied to " + ("`" + k + "`, expected a ReactNode."));
      }
      return C(c);
    }
    function Q(c, _, x, k, h) {
      return new B(
        (c || "React class") + ": " + _ + " type `" + x + "." + k + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + h + "`."
      );
    }
    function pe(c) {
      function _(x, k, h, E, S) {
        var P = x[k], j = A(P);
        if (j !== "object")
          return new B("Invalid " + E + " `" + S + "` of type `" + j + "` " + ("supplied to `" + h + "`, expected `object`."));
        for (var F in c) {
          var N = c[F];
          if (typeof N != "function")
            return Q(h, E, S, F, q(N));
          var M = N(P, F, h, E, S + "." + F, a);
          if (M)
            return M;
        }
        return null;
      }
      return C(_);
    }
    function fe(c) {
      function _(x, k, h, E, S) {
        var P = x[k], j = A(P);
        if (j !== "object")
          return new B("Invalid " + E + " `" + S + "` of type `" + j + "` " + ("supplied to `" + h + "`, expected `object`."));
        var F = t({}, x[k], c);
        for (var N in F) {
          var M = c[N];
          if (r(c, N) && typeof M != "function")
            return Q(h, E, S, N, q(M));
          if (!M)
            return new B(
              "Invalid " + E + " `" + S + "` key `" + N + "` supplied to `" + h + "`.\nBad object: " + JSON.stringify(x[k], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(c), null, "  ")
            );
          var p = M(P, N, h, E, S + "." + N, a);
          if (p)
            return p;
        }
        return null;
      }
      return C(_);
    }
    function U(c) {
      switch (typeof c) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !c;
        case "object":
          if (Array.isArray(c))
            return c.every(U);
          if (c === null || s(c))
            return !0;
          var _ = d(c);
          if (_) {
            var x = _.call(c), k;
            if (_ !== c.entries) {
              for (; !(k = x.next()).done; )
                if (!U(k.value))
                  return !1;
            } else
              for (; !(k = x.next()).done; ) {
                var h = k.value;
                if (h && !U(h[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ve(c, _) {
      return c === "symbol" ? !0 : _ ? _["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && _ instanceof Symbol : !1;
    }
    function A(c) {
      var _ = typeof c;
      return Array.isArray(c) ? "array" : c instanceof RegExp ? "object" : ve(_, c) ? "symbol" : _;
    }
    function q(c) {
      if (typeof c == "undefined" || c === null)
        return "" + c;
      var _ = A(c);
      if (_ === "object") {
        if (c instanceof Date)
          return "date";
        if (c instanceof RegExp)
          return "regexp";
      }
      return _;
    }
    function Z(c) {
      var _ = q(c);
      switch (_) {
        case "array":
        case "object":
          return "an " + _;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + _;
        default:
          return _;
      }
    }
    function _e(c) {
      return !c.constructor || !c.constructor.name ? g : c.constructor.name;
    }
    return y.checkPropTypes = o, y.resetWarningCache = o.resetWarningCache, y.PropTypes = y, y;
  }, Se;
}
var ke, Ve;
function Ct() {
  if (Ve)
    return ke;
  Ve = 1;
  var e = Le();
  function t() {
  }
  function a() {
  }
  return a.resetWarningCache = t, ke = function() {
    function r(l, s, u, f, m, d) {
      if (d !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var n = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: a,
      resetWarningCache: t
    };
    return n.PropTypes = n, n;
  }, ke;
}
if (process.env.NODE_ENV !== "production") {
  var Ot = ot(), Dt = !0;
  G.exports = Ft()(Ot.isElement, Dt);
} else
  G.exports = Ct()();
function Ee() {
  return Ee = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];
      for (var r in a)
        Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
    }
    return e;
  }, Ee.apply(this, arguments);
}
function ae(e) {
  return e.charAt(0) === "/";
}
function Pe(e, t) {
  for (var a = t, r = a + 1, o = e.length; r < o; a += 1, r += 1)
    e[a] = e[r];
  e.pop();
}
function Lt(e, t) {
  t === void 0 && (t = "");
  var a = e && e.split("/") || [], r = t && t.split("/") || [], o = e && ae(e), n = t && ae(t), l = o || n;
  if (e && ae(e) ? r = a : a.length && (r.pop(), r = r.concat(a)), !r.length)
    return "/";
  var s;
  if (r.length) {
    var u = r[r.length - 1];
    s = u === "." || u === ".." || u === "";
  } else
    s = !1;
  for (var f = 0, m = r.length; m >= 0; m--) {
    var d = r[m];
    d === "." ? Pe(r, m) : d === ".." ? (Pe(r, m), f++) : f && (Pe(r, m), f--);
  }
  if (!l)
    for (; f--; f)
      r.unshift("..");
  l && r[0] !== "" && (!r[0] || !ae(r[0])) && r.unshift("");
  var g = r.join("/");
  return s && g.substr(-1) !== "/" && (g += "/"), g;
}
function Rt(e) {
  var t = e || "/", a = "", r = "", o = t.indexOf("#");
  o !== -1 && (r = t.substr(o), t = t.substr(0, o));
  var n = t.indexOf("?");
  return n !== -1 && (a = t.substr(n), t = t.substr(0, n)), {
    pathname: t,
    search: a === "?" ? "" : a,
    hash: r === "#" ? "" : r
  };
}
function Ht(e, t, a, r) {
  var o;
  typeof e == "string" ? (o = Rt(e), o.state = t) : (o = Ee({}, e), o.pathname === void 0 && (o.pathname = ""), o.search ? o.search.charAt(0) !== "?" && (o.search = "?" + o.search) : o.search = "", o.hash ? o.hash.charAt(0) !== "#" && (o.hash = "#" + o.hash) : o.hash = "", t !== void 0 && o.state === void 0 && (o.state = t));
  try {
    o.pathname = decodeURI(o.pathname);
  } catch (n) {
    throw n instanceof URIError ? new URIError('Pathname "' + o.pathname + '" could not be decoded. This is likely caused by an invalid percent-encoding.') : n;
  }
  return a && (o.key = a), r ? o.pathname ? o.pathname.charAt(0) !== "/" && (o.pathname = Lt(o.pathname, r.pathname)) : o.pathname = r.pathname : o.pathname || (o.pathname = "/"), o;
}
var Gt = function(e, t, a, r, o, n, l, s) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error("invariant requires an error message argument");
  if (!e) {
    var u;
    if (t === void 0)
      u = new Error(
        "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
      );
    else {
      var f = [a, r, o, n, l, s], m = 0;
      u = new Error(
        t.replace(/%s/g, function() {
          return f[m++];
        })
      ), u.name = "Invariant Violation";
    }
    throw u.framesToPop = 1, u;
  }
}, Qe = Gt, Mt = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t];
    for (var r in a)
      Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
  }
  return e;
};
function At(e, t) {
  var a = {};
  for (var r in e)
    t.indexOf(r) >= 0 || !Object.prototype.hasOwnProperty.call(e, r) || (a[r] = e[r]);
  return a;
}
function It(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ze(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function $t(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Yt = function(t) {
  return !!(t.metaKey || t.altKey || t.ctrlKey || t.shiftKey);
}, ne = function(e) {
  $t(t, e);
  function t() {
    var a, r, o;
    It(this, t);
    for (var n = arguments.length, l = Array(n), s = 0; s < n; s++)
      l[s] = arguments[s];
    return o = (a = (r = Ze(this, e.call.apply(e, [this].concat(l))), r), r.handleClick = function(u) {
      if (r.props.onClick && r.props.onClick(u), !u.defaultPrevented && u.button === 0 && !r.props.target && !Yt(u)) {
        u.preventDefault();
        var f = r.context.router.history, m = r.props, d = m.replace, g = m.to;
        d ? f.replace(g) : f.push(g);
      }
    }, a), Ze(r, o);
  }
  return t.prototype.render = function() {
    var r = this.props;
    r.replace;
    var o = r.to, n = r.innerRef, l = At(r, ["replace", "to", "innerRef"]);
    Qe(this.context.router, "You should not use <Link> outside a <Router>"), Qe(o !== void 0, 'You must specify the "to" property');
    var s = this.context.router.history, u = typeof o == "string" ? Ht(o, null, null, s.location) : o, f = s.createHref(u);
    return i.createElement("a", Mt({}, l, { onClick: this.handleClick, href: f, ref: n }));
  }, t;
}(i.Component);
ne.propTypes = {
  onClick: G.exports.func,
  target: G.exports.string,
  replace: G.exports.bool,
  to: G.exports.oneOfType([G.exports.string, G.exports.object]).isRequired,
  innerRef: G.exports.oneOfType([G.exports.string, G.exports.func])
};
ne.defaultProps = {
  replace: !1
};
ne.contextTypes = {
  router: G.exports.shape({
    history: G.exports.shape({
      push: G.exports.func.isRequired,
      replace: G.exports.func.isRequired,
      createHref: G.exports.func.isRequired
    }).isRequired
  }).isRequired
};
const qt = ne, Ei = ({
  to: e,
  variant: t = "primary",
  size: a = "medium",
  chevron: r = "none",
  iconLeft: o,
  iconRight: n,
  fullWidth: l = !1,
  children: s,
  isLoading: u = !1,
  disabled: f = !1,
  className: m,
  testId: d
}) => {
  const g = t === "secondary" || t === "plain" ? "primary" : "white", y = !o && !n && r === "none";
  return /* @__PURE__ */ i.createElement(
    qt,
    {
      to: e,
      "data-testid": d,
      className: b(m, je, Ne[a], Oe[t], {
        [ze]: l,
        [Te[t]]: f,
        [Fe[a]]: o,
        [Ce[a]]: n,
        [Be[a]]: r === "left",
        [we[a]]: r === "right"
      })
    },
    /* @__PURE__ */ i.createElement(
      De,
      {
        chevron: r,
        iconLeft: o,
        iconRight: n,
        hasNoIcon: y,
        isLoading: u,
        spinnerColor: g,
        size: a
      },
      s
    )
  );
};
var Wt = { left: "Heading_3_1_3_1n94fuzl", center: "Heading_3_1_3_1n94fuzm", right: "Heading_3_1_3_1n94fuzn" }, Ut = "Heading_3_1_3_1n94fuz0", Jt = { default: "Heading_3_1_3_1n94fuz8", light: "Heading_3_1_3_1n94fuz9", lightest: "Heading_3_1_3_1n94fuza", disabled: "Heading_3_1_3_1n94fuzb", white: "Heading_3_1_3_1n94fuzc", danger: "Heading_3_1_3_1n94fuzd", shepinkDefault: "Heading_3_1_3_1n94fuze", shepinkDarken: "Heading_3_1_3_1n94fuzf", sheblueDefault: "Heading_3_1_3_1n94fuzg", sheblueDarken: "Heading_3_1_3_1n94fuzh", shegreenDefault: "Heading_3_1_3_1n94fuzi", shegreenDarken: "Heading_3_1_3_1n94fuzj", mccred: "Heading_3_1_3_1n94fuzk" }, Xt = { XXS: "Heading_3_1_3_1n94fuz1", XS: "Heading_3_1_3_1n94fuz2", S: "Heading_3_1_3_1n94fuz3", M: "Heading_3_1_3_1n94fuz4", L: "Heading_3_1_3_1n94fuz5", XL: "Heading_3_1_3_1n94fuz6", XXL: "Heading_3_1_3_1n94fuz7" };
const Re = ({
  children: e,
  size: t = "L",
  color: a = "default",
  align: r = "left",
  as: o = "h1",
  testId: n,
  ...l
}) => /* @__PURE__ */ i.createElement(
  o,
  {
    className: b(Ut, Xt[t], Jt[a], Wt[r]),
    "data-testid": n,
    ...l
  },
  e
);
var Kt = { left: "BodyText_3_1_3_10l14yxl", center: "BodyText_3_1_3_10l14yxm", right: "BodyText_3_1_3_10l14yxn" }, Vt = "BodyText_3_1_3_10l14yx0", Qt = { default: "BodyText_3_1_3_10l14yx7", lightest: "BodyText_3_1_3_10l14yx8", disabled: "BodyText_3_1_3_10l14yx9", white: "BodyText_3_1_3_10l14yxa", danger: "BodyText_3_1_3_10l14yxb", shepinkDefault: "BodyText_3_1_3_10l14yxc", shepinkDarken: "BodyText_3_1_3_10l14yxd", sheblueDefault: "BodyText_3_1_3_10l14yxe", sheblueDarken: "BodyText_3_1_3_10l14yxf", shegreenDefault: "BodyText_3_1_3_10l14yxg", shegreenDarken: "BodyText_3_1_3_10l14yxh", inherit: "BodyText_3_1_3_10l14yxi" }, Zt = { tight: "BodyText_3_1_3_10l14yx5", normal: "BodyText_3_1_3_10l14yx6" }, er = { XS: "BodyText_3_1_3_10l14yx1", S: "BodyText_3_1_3_10l14yx2", M: "BodyText_3_1_3_10l14yx3", L: "BodyText_3_1_3_10l14yx4" }, tr = { regular: "BodyText_3_1_3_10l14yxj", bold: "BodyText_3_1_3_10l14yxk" };
const X = ({
  children: e,
  size: t = "M",
  weight: a = "regular",
  lineHeight: r = "normal",
  align: o = "left",
  color: n = "inherit",
  as: l = "p",
  testId: s,
  ...u
}) => /* @__PURE__ */ i.createElement(
  l,
  {
    className: b(Vt, er[t], tr[a], Zt[r], Qt[n], Kt[o]),
    "data-testid": s,
    ...u
  },
  e
);
var rr = "LabelText_3_1_3_8f5ylw0", ar = { default: "LabelText_3_1_3_8f5ylw7", light: "LabelText_3_1_3_8f5ylw8", lightest: "LabelText_3_1_3_8f5ylw9", disabled: "LabelText_3_1_3_8f5ylwa", white: "LabelText_3_1_3_8f5ylwb", danger: "LabelText_3_1_3_8f5ylwc", shepinkDefault: "LabelText_3_1_3_8f5ylwd", shepinkDarken: "LabelText_3_1_3_8f5ylwe", sheblueDefault: "LabelText_3_1_3_8f5ylwf", sheblueDarken: "LabelText_3_1_3_8f5ylwg", shegreenDefault: "LabelText_3_1_3_8f5ylwh", shegreenDarken: "LabelText_3_1_3_8f5ylwi" }, ir = { XS: "LabelText_3_1_3_8f5ylw1", S: "LabelText_3_1_3_8f5ylw2", M: "LabelText_3_1_3_8f5ylw3", L: "LabelText_3_1_3_8f5ylw4", XL: "LabelText_3_1_3_8f5ylw5", XXL: "LabelText_3_1_3_8f5ylw6" }, or = { regular: "LabelText_3_1_3_8f5ylwj", bold: "LabelText_3_1_3_8f5ylwk" };
const le = ({
  children: e,
  size: t = "M",
  weight: a = "regular",
  color: r = "default",
  as: o = "span",
  testId: n,
  ...l
}) => /* @__PURE__ */ i.createElement(
  o,
  {
    className: b(rr, ir[t], or[a], ar[r]),
    "data-testid": n,
    ...l
  },
  e
);
var nr = "Alert_3_1_3_ttib1n0", lr = "Alert_3_1_3_ttib1n2", sr = "Alert_3_1_3_ttib1n1";
var cr = "Icon_3_1_3_1wrg9wy0", ur = { danger: "Icon_3_1_3_1wrg9wy4" }, mr = { medium: "Icon_3_1_3_1wrg9wy1", small: "Icon_3_1_3_1wrg9wy2", tiny: "Icon_3_1_3_1wrg9wy3" };
const pr = ({ icon: e, size: t = "medium", color: a, testId: r }) => /* @__PURE__ */ i.createElement("div", { className: b(cr, mr[t], ur[a]), "data-testid": r }, e), ji = ({ icon: e = !1, children: t, testId: a }) => /* @__PURE__ */ i.createElement("div", { className: nr, "data-testid": a }, e && /* @__PURE__ */ i.createElement(pr, { icon: /* @__PURE__ */ i.createElement(bt, { title: "alert" }), color: "danger" }), /* @__PURE__ */ i.createElement("div", { className: sr }, t)), Ni = ({ title: e, description: t, testId: a }) => /* @__PURE__ */ i.createElement("div", { className: lr, "data-testid": a }, e && /* @__PURE__ */ i.createElement(Re, { size: "XXS", color: "danger" }, e), /* @__PURE__ */ i.createElement(X, { color: "danger", lineHeight: "tight" }, t)), He = ({ show: e, children: t, testId: a }) => /* @__PURE__ */ i.createElement(
  X,
  {
    role: "alert",
    size: "S",
    lineHeight: "tight",
    color: "danger",
    as: "span",
    "data-testid": a,
    style: e ? void 0 : { display: "none" }
  },
  t
), Ge = ({ children: e, testId: t }) => /* @__PURE__ */ i.createElement(X, { size: "S", lineHeight: "tight", color: "lightest", as: "span", testId: t }, e);
var fr = "OptionalLabel_3_1_3_3te9lh0", vr = "OptionalLabel_3_1_3_3te9lh1", _r = "OptionalLabel_3_1_3_3te9lh2";
const dr = ({ required: e, children: t, testId: a }) => /* @__PURE__ */ i.createElement("div", { className: b(fr, e ? _r : vr), "data-testid": a }, /* @__PURE__ */ i.createElement(le, { size: "XS", color: "white" }, t));
var gr = { vertical: "LabeledForm_3_1_3_1n5uyfm2", horizontal: "LabeledForm_3_1_3_1n5uyfm3" }, br = { vertical: "LabeledForm_3_1_3_1n5uyfm4", horizontal: "LabeledForm_3_1_3_1n5uyfm5" }, hr = { vertical: "LabeledForm_3_1_3_1n5uyfm6", horizontal: "LabeledForm_3_1_3_1n5uyfm7" }, yr = { vertical: "LabeledForm_3_1_3_1n5uyfm0", horizontal: "LabeledForm_3_1_3_1n5uyfm1" }, ie = {
  borderRadius: {
    small: {
      value: "3px",
      filePath: "tokens/border-radius/border-radius.json",
      isSource: !0,
      original: {
        value: "3px"
      },
      name: "border-radius-small",
      attributes: {},
      path: [
        "border-radius",
        "small:"
      ]
    },
    medium: {
      value: "6px",
      filePath: "tokens/border-radius/border-radius.json",
      isSource: !0,
      original: {
        value: "6px"
      },
      name: "border-radius-medium",
      attributes: {},
      path: [
        "border-radius",
        "medium:"
      ]
    },
    large: {
      value: "8px",
      filePath: "tokens/border-radius/border-radius.json",
      isSource: !0,
      original: {
        value: "8px"
      },
      name: "border-radius-large",
      attributes: {},
      path: [
        "border-radius",
        "large:"
      ]
    },
    full: {
      value: "10000px",
      filePath: "tokens/border-radius/border-radius.json",
      isSource: !0,
      original: {
        value: "10000px"
      },
      name: "border-radius-full",
      attributes: {},
      path: [
        "border-radius",
        "full:"
      ]
    }
  },
  breakpoint: {
    small: {
      value: "544px",
      filePath: "tokens/breakpoint/breakpoint.json",
      isSource: !0,
      original: {
        value: "544px"
      },
      name: "breakpoint-small",
      attributes: {},
      path: [
        "breakpoint",
        "small:"
      ]
    },
    medium: {
      value: "768px",
      filePath: "tokens/breakpoint/breakpoint.json",
      isSource: !0,
      original: {
        value: "768px"
      },
      name: "breakpoint-medium",
      attributes: {},
      path: [
        "breakpoint",
        "medium:"
      ]
    },
    large: {
      value: "1012px",
      filePath: "tokens/breakpoint/breakpoint.json",
      isSource: !0,
      original: {
        value: "1012px"
      },
      name: "breakpoint-large",
      attributes: {},
      path: [
        "breakpoint",
        "large:"
      ]
    },
    xlarge: {
      value: "1280px",
      filePath: "tokens/breakpoint/breakpoint.json",
      isSource: !0,
      original: {
        value: "1280px"
      },
      name: "breakpoint-xlarge",
      attributes: {},
      path: [
        "breakpoint",
        "xlarge:"
      ]
    }
  },
  color: {
    primitive: {
      mccred50: {
        value: "#99293D",
        type: "color",
        description: "MultiCreatorCourse\u306E\u57FA\u672C\u30D6\u30E9\u30F3\u30C9\u30AB\u30E9\u30FC",
        attributes: {
          figmaName: "Primitive/Mccred/50"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#99293D",
          type: "color",
          description: "MultiCreatorCourse\u306E\u57FA\u672C\u30D6\u30E9\u30F3\u30C9\u30AB\u30E9\u30FC",
          attributes: {
            figmaName: "Primitive/Mccred/50"
          }
        },
        name: "color-primitive-mccred-50",
        path: [
          "color",
          "primitive",
          "mccred-50"
        ]
      },
      mnyorange50: {
        value: "#E48A57",
        type: "color",
        description: "SHEmoney\u306E\u57FA\u672C\u30D6\u30E9\u30F3\u30C9\u30AB\u30E9\u30FC",
        attributes: {
          figmaName: "Primitive/Mnyorange/50"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#E48A57",
          type: "color",
          description: "SHEmoney\u306E\u57FA\u672C\u30D6\u30E9\u30F3\u30C9\u30AB\u30E9\u30FC",
          attributes: {
            figmaName: "Primitive/Mnyorange/50"
          }
        },
        name: "color-primitive-mnyorange-50",
        path: [
          "color",
          "primitive",
          "mnyorange-50"
        ]
      },
      shepink50: {
        value: "#FBF7F7",
        type: "color",
        description: "\u80CC\u666F\u306E\u8272 / \u5927\u304D\u3081\u306E\u30AB\u30FC\u30C9\u3067\u4E0A\u306B\u30C6\u30AD\u30B9\u30C8\u3092\u8F09\u305B\u308B\u7B49\u306E\u7528\u9014\u3067\u3042\u308C\u3070\u3053\u3061\u3089\u3092\u63A8\u5968",
        attributes: {
          figmaName: "Primitive/SHEColors/Pink/50"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#FBF7F7",
          type: "color",
          description: "\u80CC\u666F\u306E\u8272 / \u5927\u304D\u3081\u306E\u30AB\u30FC\u30C9\u3067\u4E0A\u306B\u30C6\u30AD\u30B9\u30C8\u3092\u8F09\u305B\u308B\u7B49\u306E\u7528\u9014\u3067\u3042\u308C\u3070\u3053\u3061\u3089\u3092\u63A8\u5968",
          attributes: {
            figmaName: "Primitive/SHEColors/Pink/50"
          }
        },
        name: "color-primitive-shepink-50",
        path: [
          "color",
          "primitive",
          "shepink-50"
        ]
      },
      shepink100: {
        value: "#F9F2F2",
        type: "color",
        description: "\u80CC\u666F\u306E\u8272 / \u30E9\u30D9\u30EB\u306A\u3069\u5C0F\u3055\u306A\u30D1\u30FC\u30C4\u306E\u80CC\u666F\u306F\u3053\u3061\u3089\u3092\u63A8\u5968 / YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Pink/100"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#F9F2F2",
          type: "color",
          description: "\u80CC\u666F\u306E\u8272 / \u30E9\u30D9\u30EB\u306A\u3069\u5C0F\u3055\u306A\u30D1\u30FC\u30C4\u306E\u80CC\u666F\u306F\u3053\u3061\u3089\u3092\u63A8\u5968 / YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Pink/100"
          }
        },
        name: "color-primitive-shepink-100",
        path: [
          "color",
          "primitive",
          "shepink-100"
        ]
      },
      shepink200: {
        value: "#F2E5E5",
        type: "color",
        description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Pink/200"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#F2E5E5",
          type: "color",
          description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Pink/200"
          }
        },
        name: "color-primitive-shepink-200",
        path: [
          "color",
          "primitive",
          "shepink-200"
        ]
      },
      shepink300: {
        value: "#EFD6D5",
        type: "color",
        description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Pink/300"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#EFD6D5",
          type: "color",
          description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Pink/300"
          }
        },
        name: "color-primitive-shepink-300",
        path: [
          "color",
          "primitive",
          "shepink-300"
        ]
      },
      shepink400: {
        value: "#D6A1A1",
        type: "color",
        description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Pink/400"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#D6A1A1",
          type: "color",
          description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Pink/400"
          }
        },
        name: "color-primitive-shepink-400",
        path: [
          "color",
          "primitive",
          "shepink-400"
        ]
      },
      shepink500: {
        value: "#C38383",
        type: "color",
        description: "\u767D\u80CC\u666F\u6642\u306B\u4F7F\u7528\u3067\u304D\u308B\u30C6\u30AD\u30B9\u30C8\u30AB\u30E9\u30FC / \u5857\u308A\u3067\u4F7F\u7528\u3067\u304D\u308B\u4E00\u756A\u6FC3\u3044\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Pink/500"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#C38383",
          type: "color",
          description: "\u767D\u80CC\u666F\u6642\u306B\u4F7F\u7528\u3067\u304D\u308B\u30C6\u30AD\u30B9\u30C8\u30AB\u30E9\u30FC / \u5857\u308A\u3067\u4F7F\u7528\u3067\u304D\u308B\u4E00\u756A\u6FC3\u3044\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Pink/500"
          }
        },
        name: "color-primitive-shepink-500",
        path: [
          "color",
          "primitive",
          "shepink-500"
        ]
      },
      shepink600: {
        value: "#BA7D7D",
        type: "color",
        description: "\u80CC\u666F\u8272\u306E\u4E0A\u306B\u306E\u305B\u308B\u30C6\u30AD\u30B9\u30C8\u30AB\u30E9\u30FC / \u5857\u308A\u3067\u306F\u57FA\u672C\u7684\u306B\u4F7F\u7528\u3057\u306A\u3044",
        attributes: {
          figmaName: "Primitive/SHEColors/Pink/600"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#BA7D7D",
          type: "color",
          description: "\u80CC\u666F\u8272\u306E\u4E0A\u306B\u306E\u305B\u308B\u30C6\u30AD\u30B9\u30C8\u30AB\u30E9\u30FC / \u5857\u308A\u3067\u306F\u57FA\u672C\u7684\u306B\u4F7F\u7528\u3057\u306A\u3044",
          attributes: {
            figmaName: "Primitive/SHEColors/Pink/600"
          }
        },
        name: "color-primitive-shepink-600",
        path: [
          "color",
          "primitive",
          "shepink-600"
        ]
      },
      sheblue50: {
        value: "#F5F9FA",
        type: "color",
        description: "\u80CC\u666F\u306E\u8272 / \u5927\u304D\u3081\u306E\u30AB\u30FC\u30C9\u3067\u4E0A\u306B\u30C6\u30AD\u30B9\u30C8\u3092\u8F09\u305B\u308B\u7B49\u306E\u7528\u9014\u3067\u3042\u308C\u3070\u3053\u3061\u3089\u3092\u63A8\u5968",
        attributes: {
          figmaName: "Primitive/SHEColors/Blue/50"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#F5F9FA",
          type: "color",
          description: "\u80CC\u666F\u306E\u8272 / \u5927\u304D\u3081\u306E\u30AB\u30FC\u30C9\u3067\u4E0A\u306B\u30C6\u30AD\u30B9\u30C8\u3092\u8F09\u305B\u308B\u7B49\u306E\u7528\u9014\u3067\u3042\u308C\u3070\u3053\u3061\u3089\u3092\u63A8\u5968",
          attributes: {
            figmaName: "Primitive/SHEColors/Blue/50"
          }
        },
        name: "color-primitive-sheblue-50",
        path: [
          "color",
          "primitive",
          "sheblue-50"
        ]
      },
      sheblue100: {
        value: "#F0F6F7",
        type: "color",
        description: "\u80CC\u666F\u306E\u8272 / \u30E9\u30D9\u30EB\u306A\u3069\u5C0F\u3055\u306A\u30D1\u30FC\u30C4\u306E\u80CC\u666F\u306F\u3053\u3061\u3089\u3092\u63A8\u5968 / YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Blue/100"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#F0F6F7",
          type: "color",
          description: "\u80CC\u666F\u306E\u8272 / \u30E9\u30D9\u30EB\u306A\u3069\u5C0F\u3055\u306A\u30D1\u30FC\u30C4\u306E\u80CC\u666F\u306F\u3053\u3061\u3089\u3092\u63A8\u5968 / YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Blue/100"
          }
        },
        name: "color-primitive-sheblue-100",
        path: [
          "color",
          "primitive",
          "sheblue-100"
        ]
      },
      sheblue200: {
        value: "#DFEAED",
        type: "color",
        description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Blue/200"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#DFEAED",
          type: "color",
          description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Blue/200"
          }
        },
        name: "color-primitive-sheblue-200",
        path: [
          "color",
          "primitive",
          "sheblue-200"
        ]
      },
      sheblue300: {
        value: "#D7E4EA",
        type: "color",
        attributes: {
          figmaName: "Primitive/SHEColors/Blue/300"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#D7E4EA",
          type: "color",
          attributes: {
            figmaName: "Primitive/SHEColors/Blue/300"
          }
        },
        name: "color-primitive-sheblue-300",
        path: [
          "color",
          "primitive",
          "sheblue-300"
        ]
      },
      sheblue400: {
        value: "#BAD1DB",
        type: "color",
        description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Blue/400"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#BAD1DB",
          type: "color",
          description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Blue/400"
          }
        },
        name: "color-primitive-sheblue-400",
        path: [
          "color",
          "primitive",
          "sheblue-400"
        ]
      },
      sheblue500: {
        value: "#6B9BAA",
        type: "color",
        description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Blue/500"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#6B9BAA",
          type: "color",
          description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Blue/500"
          }
        },
        name: "color-primitive-sheblue-500",
        path: [
          "color",
          "primitive",
          "sheblue-500"
        ]
      },
      sheblue600: {
        value: "#4D8193",
        type: "color",
        description: "\u80CC\u666F\u8272\u306E\u4E0A\u306B\u306E\u305B\u308B\u30C6\u30AD\u30B9\u30C8\u30AB\u30E9\u30FC / \u5857\u308A\u3067\u306F\u57FA\u672C\u7684\u306B\u4F7F\u7528\u3057\u306A\u3044",
        attributes: {
          figmaName: "Primitive/SHEColors/Blue/600"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#4D8193",
          type: "color",
          description: "\u80CC\u666F\u8272\u306E\u4E0A\u306B\u306E\u305B\u308B\u30C6\u30AD\u30B9\u30C8\u30AB\u30E9\u30FC / \u5857\u308A\u3067\u306F\u57FA\u672C\u7684\u306B\u4F7F\u7528\u3057\u306A\u3044",
          attributes: {
            figmaName: "Primitive/SHEColors/Blue/600"
          }
        },
        name: "color-primitive-sheblue-600",
        path: [
          "color",
          "primitive",
          "sheblue-600"
        ]
      },
      shegreen50: {
        value: "#F6F9F8",
        type: "color",
        description: "\u80CC\u666F\u306E\u8272 / \u5927\u304D\u3081\u306E\u30AB\u30FC\u30C9\u3067\u4E0A\u306B\u30C6\u30AD\u30B9\u30C8\u3092\u8F09\u305B\u308B\u7B49\u306E\u7528\u9014\u3067\u3042\u308C\u3070\u3053\u3061\u3089\u3092\u63A8\u5968",
        attributes: {
          figmaName: "Primitive/SHEColors/Green/50"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#F6F9F8",
          type: "color",
          description: "\u80CC\u666F\u306E\u8272 / \u5927\u304D\u3081\u306E\u30AB\u30FC\u30C9\u3067\u4E0A\u306B\u30C6\u30AD\u30B9\u30C8\u3092\u8F09\u305B\u308B\u7B49\u306E\u7528\u9014\u3067\u3042\u308C\u3070\u3053\u3061\u3089\u3092\u63A8\u5968",
          attributes: {
            figmaName: "Primitive/SHEColors/Green/50"
          }
        },
        name: "color-primitive-shegreen-50",
        path: [
          "color",
          "primitive",
          "shegreen-50"
        ]
      },
      shegreen100: {
        value: "#EFF4F3",
        type: "color",
        description: "\u80CC\u666F\u306E\u8272 / \u30E9\u30D9\u30EB\u306A\u3069\u5C0F\u3055\u306A\u30D1\u30FC\u30C4\u306E\u80CC\u666F\u306F\u3053\u3061\u3089\u3092\u63A8\u5968 / YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Green/100"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#EFF4F3",
          type: "color",
          description: "\u80CC\u666F\u306E\u8272 / \u30E9\u30D9\u30EB\u306A\u3069\u5C0F\u3055\u306A\u30D1\u30FC\u30C4\u306E\u80CC\u666F\u306F\u3053\u3061\u3089\u3092\u63A8\u5968 / YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Green/100"
          }
        },
        name: "color-primitive-shegreen-100",
        path: [
          "color",
          "primitive",
          "shegreen-100"
        ]
      },
      shegreen200: {
        value: "#E6EFED",
        type: "color",
        description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Green/200"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#E6EFED",
          type: "color",
          description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Green/200"
          }
        },
        name: "color-primitive-shegreen-200",
        path: [
          "color",
          "primitive",
          "shegreen-200"
        ]
      },
      shegreen300: {
        value: "#CFE0DC",
        type: "color",
        attributes: {
          figmaName: "Primitive/SHEColors/Green/300"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#CFE0DC",
          type: "color",
          attributes: {
            figmaName: "Primitive/SHEColors/Green/300"
          }
        },
        name: "color-primitive-shegreen-300",
        path: [
          "color",
          "primitive",
          "shegreen-300"
        ]
      },
      shegreen400: {
        value: "#97B7B6",
        type: "color",
        description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Green/400"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#97B7B6",
          type: "color",
          description: "YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Green/400"
          }
        },
        name: "color-primitive-shegreen-400",
        path: [
          "color",
          "primitive",
          "shegreen-400"
        ]
      },
      shegreen500: {
        value: "#729897",
        type: "color",
        description: "\u767D\u80CC\u666F\u6642\u306B\u4F7F\u7528\u3067\u304D\u308B\u30C6\u30AD\u30B9\u30C8\u30AB\u30E9\u30FC / \u5857\u308A\u3067\u4F7F\u7528\u3067\u304D\u308B\u4E00\u756A\u6FC3\u3044\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Green/500"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#729897",
          type: "color",
          description: "\u767D\u80CC\u666F\u6642\u306B\u4F7F\u7528\u3067\u304D\u308B\u30C6\u30AD\u30B9\u30C8\u30AB\u30E9\u30FC / \u5857\u308A\u3067\u4F7F\u7528\u3067\u304D\u308B\u4E00\u756A\u6FC3\u3044\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Green/500"
          }
        },
        name: "color-primitive-shegreen-500",
        path: [
          "color",
          "primitive",
          "shegreen-500"
        ]
      },
      shegreen600: {
        value: "#3E6770",
        type: "color",
        description: "\u80CC\u666F\u8272\u306E\u4E0A\u306B\u306E\u305B\u308B\u30C6\u30AD\u30B9\u30C8\u30AB\u30E9\u30FC / \u5857\u308A\u3067\u306F\u57FA\u672C\u7684\u306B\u4F7F\u7528\u3057\u306A\u3044 / YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
        attributes: {
          figmaName: "Primitive/SHEColors/Green/600"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#3E6770",
          type: "color",
          description: "\u80CC\u666F\u8272\u306E\u4E0A\u306B\u306E\u305B\u308B\u30C6\u30AD\u30B9\u30C8\u30AB\u30E9\u30FC / \u5857\u308A\u3067\u306F\u57FA\u672C\u7684\u306B\u4F7F\u7528\u3057\u306A\u3044 / YOPPY\u3055\u3093\u4F5C\u6210\u306E\u30AB\u30E9\u30FC\u30D1\u30EC\u30C3\u30C8\u307E\u307E\u8272",
          attributes: {
            figmaName: "Primitive/SHEColors/Green/600"
          }
        },
        name: "color-primitive-shegreen-600",
        path: [
          "color",
          "primitive",
          "shegreen-600"
        ]
      },
      black: {
        value: "#1F2D32",
        type: "color",
        attributes: {
          figmaName: "Primitive/Black&White/Black"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#1F2D32",
          type: "color",
          attributes: {
            figmaName: "Primitive/Black&White/Black"
          }
        },
        name: "color-primitive-black",
        path: [
          "color",
          "primitive",
          "black"
        ]
      },
      white: {
        value: "#FFFFFF",
        type: "color",
        attributes: {
          figmaName: "Primitive/Black&White/White"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#FFFFFF",
          type: "color",
          attributes: {
            figmaName: "Primitive/Black&White/White"
          }
        },
        name: "color-primitive-white",
        path: [
          "color",
          "primitive",
          "white"
        ]
      },
      gray0: {
        value: "#ffffff",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/0"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#ffffff",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/0"
          }
        },
        name: "color-primitive-gray-0",
        path: [
          "color",
          "primitive",
          "gray-0"
        ]
      },
      gray10: {
        value: "#fbfbfb",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/10"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#fbfbfb",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/10"
          }
        },
        name: "color-primitive-gray-10",
        path: [
          "color",
          "primitive",
          "gray-10"
        ]
      },
      gray20: {
        value: "#f6f7f7",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/20"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#f6f7f7",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/20"
          }
        },
        name: "color-primitive-gray-20",
        path: [
          "color",
          "primitive",
          "gray-20"
        ]
      },
      gray30: {
        value: "#edeeef",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/30"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#edeeef",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/30"
          }
        },
        name: "color-primitive-gray-30",
        path: [
          "color",
          "primitive",
          "gray-30"
        ]
      },
      gray40: {
        value: "#e2e4e4",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/40"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#e2e4e4",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/40"
          }
        },
        name: "color-primitive-gray-40",
        path: [
          "color",
          "primitive",
          "gray-40"
        ]
      },
      gray50: {
        value: "#c7cbcc",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/50"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#c7cbcc",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/50"
          }
        },
        name: "color-primitive-gray-50",
        path: [
          "color",
          "primitive",
          "gray-50"
        ]
      },
      gray60: {
        value: "#babebf",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/60"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#babebf",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/60"
          }
        },
        name: "color-primitive-gray-60",
        path: [
          "color",
          "primitive",
          "gray-60"
        ]
      },
      gray70: {
        value: "#aeb3b5",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/70"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#aeb3b5",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/70"
          }
        },
        name: "color-primitive-gray-70",
        path: [
          "color",
          "primitive",
          "gray-70"
        ]
      },
      gray80: {
        value: "#a1a7a9",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/80"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#a1a7a9",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/80"
          }
        },
        name: "color-primitive-gray-80",
        path: [
          "color",
          "primitive",
          "gray-80"
        ]
      },
      gray90: {
        value: "#939a9d",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/90"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#939a9d",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/90"
          }
        },
        name: "color-primitive-gray-90",
        path: [
          "color",
          "primitive",
          "gray-90"
        ]
      },
      gray100: {
        value: "#849194",
        type: "color",
        description: "foundation \uFF08Color Generator \uFF09\u306E Profiles Atlassian / Neutral \u3067#1F2D32\u30D9\u30FC\u30B9\u306B\u4F5C\u6210\u3057\u305F\u30B0\u30EC\u30FC\u30B9\u30B1\u30FC\u30EB\u304B\u3089\u6587\u5B57\u8272\u3068\u3057\u3066\u3088\u308A\u306A\u3058\u3080\u3088\u3046\u306B\u8272\u5473\u3092\u8ABF\u6574\u6E08\u307F",
        attributes: {
          figmaName: "Primitive/Gray/100"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#849194",
          type: "color",
          description: "foundation \uFF08Color Generator \uFF09\u306E Profiles Atlassian / Neutral \u3067#1F2D32\u30D9\u30FC\u30B9\u306B\u4F5C\u6210\u3057\u305F\u30B0\u30EC\u30FC\u30B9\u30B1\u30FC\u30EB\u304B\u3089\u6587\u5B57\u8272\u3068\u3057\u3066\u3088\u308A\u306A\u3058\u3080\u3088\u3046\u306B\u8272\u5473\u3092\u8ABF\u6574\u6E08\u307F",
          attributes: {
            figmaName: "Primitive/Gray/100"
          }
        },
        name: "color-primitive-gray-100",
        path: [
          "color",
          "primitive",
          "gray-100"
        ]
      },
      gray200: {
        value: "#798184",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/200"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#798184",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/200"
          }
        },
        name: "color-primitive-gray-200",
        path: [
          "color",
          "primitive",
          "gray-200"
        ]
      },
      gray300: {
        value: "#6b7478",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/300"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#6b7478",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/300"
          }
        },
        name: "color-primitive-gray-300",
        path: [
          "color",
          "primitive",
          "gray-300"
        ]
      },
      gray400: {
        value: "#606a6d",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/400"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#606a6d",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/400"
          }
        },
        name: "color-primitive-gray-400",
        path: [
          "color",
          "primitive",
          "gray-400"
        ]
      },
      gray500: {
        value: "#535d61",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/500"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#535d61",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/500"
          }
        },
        name: "color-primitive-gray-500",
        path: [
          "color",
          "primitive",
          "gray-500"
        ]
      },
      gray600: {
        value: "#475357",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/600"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#475357",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/600"
          }
        },
        name: "color-primitive-gray-600",
        path: [
          "color",
          "primitive",
          "gray-600"
        ]
      },
      gray700: {
        value: "#384449",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/700"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#384449",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/700"
          }
        },
        name: "color-primitive-gray-700",
        path: [
          "color",
          "primitive",
          "gray-700"
        ]
      },
      gray800: {
        value: "#2a383c",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/800"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#2a383c",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/800"
          }
        },
        name: "color-primitive-gray-800",
        path: [
          "color",
          "primitive",
          "gray-800"
        ]
      },
      gray900: {
        value: "#1f2d32",
        type: "color",
        attributes: {
          figmaName: "Primitive/Gray/900"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#1f2d32",
          type: "color",
          attributes: {
            figmaName: "Primitive/Gray/900"
          }
        },
        name: "color-primitive-gray-900",
        path: [
          "color",
          "primitive",
          "gray-900"
        ]
      },
      navy50: {
        value: "#edeff1",
        type: "color",
        attributes: {
          figmaName: "Primitive/Navy/50"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#edeff1",
          type: "color",
          attributes: {
            figmaName: "Primitive/Navy/50"
          }
        },
        name: "color-primitive-navy-50",
        path: [
          "color",
          "primitive",
          "navy-50"
        ]
      },
      navy75: {
        value: "#b6bec5",
        type: "color",
        attributes: {
          figmaName: "Primitive/Navy/75"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#b6bec5",
          type: "color",
          attributes: {
            figmaName: "Primitive/Navy/75"
          }
        },
        name: "color-primitive-navy-75",
        path: [
          "color",
          "primitive",
          "navy-75"
        ]
      },
      navy100: {
        value: "#97a3ad",
        type: "color",
        attributes: {
          figmaName: "Primitive/Navy/100"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#97a3ad",
          type: "color",
          attributes: {
            figmaName: "Primitive/Navy/100"
          }
        },
        name: "color-primitive-navy-100",
        path: [
          "color",
          "primitive",
          "navy-100"
        ]
      },
      navy200: {
        value: "#6a7b8a",
        type: "color",
        attributes: {
          figmaName: "Primitive/Navy/200"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#6a7b8a",
          type: "color",
          attributes: {
            figmaName: "Primitive/Navy/200"
          }
        },
        name: "color-primitive-navy-200",
        path: [
          "color",
          "primitive",
          "navy-200"
        ]
      },
      navy300: {
        value: "#4c6072",
        type: "color",
        attributes: {
          figmaName: "Primitive/Navy/300"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#4c6072",
          type: "color",
          attributes: {
            figmaName: "Primitive/Navy/300"
          }
        },
        name: "color-primitive-navy-300",
        path: [
          "color",
          "primitive",
          "navy-300"
        ]
      },
      navy400: {
        value: "#354350",
        type: "color",
        attributes: {
          figmaName: "Primitive/Navy/400"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#354350",
          type: "color",
          attributes: {
            figmaName: "Primitive/Navy/400"
          }
        },
        name: "color-primitive-navy-400",
        path: [
          "color",
          "primitive",
          "navy-400"
        ]
      },
      navy500: {
        value: "#2e3b46",
        type: "color",
        attributes: {
          figmaName: "Primitive/Navy/500"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#2e3b46",
          type: "color",
          attributes: {
            figmaName: "Primitive/Navy/500"
          }
        },
        name: "color-primitive-navy-500",
        path: [
          "color",
          "primitive",
          "navy-500"
        ]
      },
      red40: {
        value: "#FDF6F8",
        type: "color",
        attributes: {
          figmaName: "Primitive/Red/40"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#FDF6F8",
          type: "color",
          attributes: {
            figmaName: "Primitive/Red/40"
          }
        },
        name: "color-primitive-red-40",
        path: [
          "color",
          "primitive",
          "red-40"
        ]
      },
      red50: {
        value: "#fceef1",
        type: "color",
        attributes: {
          figmaName: "Primitive/Red/50"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#fceef1",
          type: "color",
          attributes: {
            figmaName: "Primitive/Red/50"
          }
        },
        name: "color-primitive-red-50",
        path: [
          "color",
          "primitive",
          "red-50"
        ]
      },
      red75: {
        value: "#f2b9c6",
        type: "color",
        attributes: {
          figmaName: "Primitive/Red/75"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#f2b9c6",
          type: "color",
          attributes: {
            figmaName: "Primitive/Red/75"
          }
        },
        name: "color-primitive-red-75",
        path: [
          "color",
          "primitive",
          "red-75"
        ]
      },
      red100: {
        value: "#ec9caf",
        type: "color",
        attributes: {
          figmaName: "Primitive/Red/100"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#ec9caf",
          type: "color",
          attributes: {
            figmaName: "Primitive/Red/100"
          }
        },
        name: "color-primitive-red-100",
        path: [
          "color",
          "primitive",
          "red-100"
        ]
      },
      red200: {
        value: "#e4718c",
        type: "color",
        attributes: {
          figmaName: "Primitive/Red/200"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#e4718c",
          type: "color",
          attributes: {
            figmaName: "Primitive/Red/200"
          }
        },
        name: "color-primitive-red-200",
        path: [
          "color",
          "primitive",
          "red-200"
        ]
      },
      red300: {
        value: "#df5475",
        type: "color",
        attributes: {
          figmaName: "Primitive/Red/300"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#df5475",
          type: "color",
          attributes: {
            figmaName: "Primitive/Red/300"
          }
        },
        name: "color-primitive-red-300",
        path: [
          "color",
          "primitive",
          "red-300"
        ]
      },
      red350: {
        value: "#C34160",
        type: "color",
        attributes: {
          figmaName: "Primitive/Red/350"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#C34160",
          type: "color",
          attributes: {
            figmaName: "Primitive/Red/350"
          }
        },
        name: "color-primitive-red-350",
        path: [
          "color",
          "primitive",
          "red-350"
        ]
      },
      red400: {
        value: "#9c3b52",
        type: "color",
        attributes: {
          figmaName: "Primitive/Red/400"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#9c3b52",
          type: "color",
          attributes: {
            figmaName: "Primitive/Red/400"
          }
        },
        name: "color-primitive-red-400",
        path: [
          "color",
          "primitive",
          "red-400"
        ]
      },
      red500: {
        value: "#883347",
        type: "color",
        attributes: {
          figmaName: "Primitive/Red/500"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#883347",
          type: "color",
          attributes: {
            figmaName: "Primitive/Red/500"
          }
        },
        name: "color-primitive-red-500",
        path: [
          "color",
          "primitive",
          "red-500"
        ]
      },
      green40: {
        value: "#F5FAF4",
        type: "color",
        attributes: {
          figmaName: "Primitive/Green/40"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#F5FAF4",
          type: "color",
          attributes: {
            figmaName: "Primitive/Green/40"
          }
        },
        name: "color-primitive-green-40",
        path: [
          "color",
          "primitive",
          "green-40"
        ]
      },
      green50: {
        value: "#edf7ec",
        type: "color",
        attributes: {
          figmaName: "Primitive/Green/50"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#edf7ec",
          type: "color",
          attributes: {
            figmaName: "Primitive/Green/50"
          }
        },
        name: "color-primitive-green-50",
        path: [
          "color",
          "primitive",
          "green-50"
        ]
      },
      green75: {
        value: "#b5deb2",
        type: "color",
        attributes: {
          figmaName: "Primitive/Green/75"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#b5deb2",
          type: "color",
          attributes: {
            figmaName: "Primitive/Green/75"
          }
        },
        name: "color-primitive-green-75",
        path: [
          "color",
          "primitive",
          "green-75"
        ]
      },
      green100: {
        value: "#96d091",
        type: "color",
        attributes: {
          figmaName: "Primitive/Green/100"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#96d091",
          type: "color",
          attributes: {
            figmaName: "Primitive/Green/100"
          }
        },
        name: "color-primitive-green-100",
        path: [
          "color",
          "primitive",
          "green-100"
        ]
      },
      green200: {
        value: "#69bc62",
        type: "color",
        attributes: {
          figmaName: "Primitive/Green/200"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#69bc62",
          type: "color",
          attributes: {
            figmaName: "Primitive/Green/200"
          }
        },
        name: "color-primitive-green-200",
        path: [
          "color",
          "primitive",
          "green-200"
        ]
      },
      green300: {
        value: "#4aae42",
        type: "color",
        attributes: {
          figmaName: "Primitive/Green/300"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#4aae42",
          type: "color",
          attributes: {
            figmaName: "Primitive/Green/300"
          }
        },
        name: "color-primitive-green-300",
        path: [
          "color",
          "primitive",
          "green-300"
        ]
      },
      green400: {
        value: "#347a2e",
        type: "color",
        attributes: {
          figmaName: "Primitive/Green/400"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#347a2e",
          type: "color",
          attributes: {
            figmaName: "Primitive/Green/400"
          }
        },
        name: "color-primitive-green-400",
        path: [
          "color",
          "primitive",
          "green-400"
        ]
      },
      green500: {
        value: "#2d6a28",
        type: "color",
        attributes: {
          figmaName: "Primitive/Green/500"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#2d6a28",
          type: "color",
          attributes: {
            figmaName: "Primitive/Green/500"
          }
        },
        name: "color-primitive-green-500",
        path: [
          "color",
          "primitive",
          "green-500"
        ]
      },
      blue50: {
        value: "#eaf3fc",
        type: "color",
        attributes: {
          figmaName: "Primitive/Blue/50"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#eaf3fc",
          type: "color",
          attributes: {
            figmaName: "Primitive/Blue/50"
          }
        },
        name: "color-primitive-blue-50",
        path: [
          "color",
          "primitive",
          "blue-50"
        ]
      },
      blue75: {
        value: "#a8cff1",
        type: "color",
        attributes: {
          figmaName: "Primitive/Blue/75"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#a8cff1",
          type: "color",
          attributes: {
            figmaName: "Primitive/Blue/75"
          }
        },
        name: "color-primitive-blue-75",
        path: [
          "color",
          "primitive",
          "blue-75"
        ]
      },
      blue100: {
        value: "#84bbec",
        type: "color",
        attributes: {
          figmaName: "Primitive/Blue/100"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#84bbec",
          type: "color",
          attributes: {
            figmaName: "Primitive/Blue/100"
          }
        },
        name: "color-primitive-blue-100",
        path: [
          "color",
          "primitive",
          "blue-100"
        ]
      },
      blue200: {
        value: "#4f9ee4",
        type: "color",
        attributes: {
          figmaName: "Primitive/Blue/200"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#4f9ee4",
          type: "color",
          attributes: {
            figmaName: "Primitive/Blue/200"
          }
        },
        name: "color-primitive-blue-200",
        path: [
          "color",
          "primitive",
          "blue-200"
        ]
      },
      blue300: {
        value: "#2b8ade",
        type: "color",
        attributes: {
          figmaName: "Primitive/Blue/300"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#2b8ade",
          type: "color",
          attributes: {
            figmaName: "Primitive/Blue/300"
          }
        },
        name: "color-primitive-blue-300",
        path: [
          "color",
          "primitive",
          "blue-300"
        ]
      },
      blue400: {
        value: "#1e619b",
        type: "color",
        attributes: {
          figmaName: "Primitive/Blue/400"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#1e619b",
          type: "color",
          attributes: {
            figmaName: "Primitive/Blue/400"
          }
        },
        name: "color-primitive-blue-400",
        path: [
          "color",
          "primitive",
          "blue-400"
        ]
      },
      blue500: {
        value: "#1a5487",
        type: "color",
        attributes: {
          figmaName: "Primitive/Blue/500"
        },
        filePath: "tokens/color/primitive.json",
        isSource: !0,
        original: {
          value: "#1a5487",
          type: "color",
          attributes: {
            figmaName: "Primitive/Blue/500"
          }
        },
        name: "color-primitive-blue-500",
        path: [
          "color",
          "primitive",
          "blue-500"
        ]
      }
    },
    bg: {
      white: {
        value: "#FFFFFF",
        type: "color",
        attributes: {
          figmaName: "Background/white"
        },
        filePath: "tokens/color/semantics/background.json",
        isSource: !0,
        original: {
          value: "{color.primitive.white.value}",
          type: "color",
          attributes: {
            figmaName: "Background/white"
          }
        },
        name: "color-bg-white",
        path: [
          "color",
          "bg",
          "white"
        ]
      },
      gray: {
        value: "#f6f7f7",
        type: "color",
        attributes: {
          figmaName: "Background/gray"
        },
        filePath: "tokens/color/semantics/background.json",
        isSource: !0,
        original: {
          value: "{color.primitive.gray-20.value}",
          type: "color",
          attributes: {
            figmaName: "Background/gray"
          }
        },
        name: "color-bg-gray",
        path: [
          "color",
          "bg",
          "gray"
        ]
      },
      danger: {
        value: "#FDF6F8",
        type: "color",
        attributes: {
          figmaName: "Background/danger"
        },
        filePath: "tokens/color/semantics/background.json",
        isSource: !0,
        original: {
          value: "{color.primitive.red-40.value}",
          type: "color",
          attributes: {
            figmaName: "Background/danger"
          }
        },
        name: "color-bg-danger",
        path: [
          "color",
          "bg",
          "danger"
        ]
      },
      success: {
        value: "#F5FAF4",
        type: "color",
        attributes: {
          figmaName: "Background/success"
        },
        filePath: "tokens/color/semantics/background.json",
        isSource: !0,
        original: {
          value: "{color.primitive.green-40.value}",
          type: "color",
          attributes: {
            figmaName: "Background/success"
          }
        },
        name: "color-bg-success",
        path: [
          "color",
          "bg",
          "success"
        ]
      },
      shepinkLight: {
        value: "#FBF7F7",
        type: "color",
        attributes: {
          figmaName: "Background/SHEPink/light"
        },
        filePath: "tokens/color/semantics/background.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shepink-50.value}",
          type: "color",
          attributes: {
            figmaName: "Background/SHEPink/light"
          }
        },
        name: "color-bg-shepink-light",
        path: [
          "color",
          "bg",
          "shepink-light"
        ]
      },
      shepinkDefault: {
        value: "#F9F2F2",
        type: "color",
        attributes: {
          figmaName: "Background/SHEPink/default"
        },
        filePath: "tokens/color/semantics/background.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shepink-100.value}",
          type: "color",
          attributes: {
            figmaName: "Background/SHEPink/default"
          }
        },
        name: "color-bg-shepink-default",
        path: [
          "color",
          "bg",
          "shepink-default"
        ]
      },
      sheblueLight: {
        value: "#F5F9FA",
        type: "color",
        attributes: {
          figmaName: "Background/SHEBlue/light"
        },
        filePath: "tokens/color/semantics/background.json",
        isSource: !0,
        original: {
          value: "{color.primitive.sheblue-50.value}",
          type: "color",
          attributes: {
            figmaName: "Background/SHEBlue/light"
          }
        },
        name: "color-bg-sheblue-light",
        path: [
          "color",
          "bg",
          "sheblue-light"
        ]
      },
      sheblueDefault: {
        value: "#F0F6F7",
        type: "color",
        attributes: {
          figmaName: "Background/SHEBlue/default"
        },
        filePath: "tokens/color/semantics/background.json",
        isSource: !0,
        original: {
          value: "{color.primitive.sheblue-100.value}",
          type: "color",
          attributes: {
            figmaName: "Background/SHEBlue/default"
          }
        },
        name: "color-bg-sheblue-default",
        path: [
          "color",
          "bg",
          "sheblue-default"
        ]
      },
      shegreenLight: {
        value: "#F6F9F8",
        type: "color",
        attributes: {
          figmaName: "Background/SHEGreen/light"
        },
        filePath: "tokens/color/semantics/background.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shegreen-50.value}",
          type: "color",
          attributes: {
            figmaName: "Background/SHEGreen/light"
          }
        },
        name: "color-bg-shegreen-light",
        path: [
          "color",
          "bg",
          "shegreen-light"
        ]
      },
      shegreenDefault: {
        value: "#EFF4F3",
        type: "color",
        attributes: {
          figmaName: "Background/SHEGreen/default"
        },
        filePath: "tokens/color/semantics/background.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shegreen-100.value}",
          type: "color",
          attributes: {
            figmaName: "Background/SHEGreen/default"
          }
        },
        name: "color-bg-shegreen-default",
        path: [
          "color",
          "bg",
          "shegreen-default"
        ]
      }
    },
    border: {
      default: {
        value: "#edeeef",
        type: "color",
        attributes: {
          figmaName: "Border/default"
        },
        description: "\u80CC\u666F\u304CWhite\u306E\u5834\u5408\u306B\u4F7F\u7528\u3059\u308B\u57FA\u672C\u306E\u30DC\u30FC\u30C0\u30FC\u306E\u8272",
        filePath: "tokens/color/semantics/border.json",
        isSource: !0,
        original: {
          value: "{color.primitive.gray-30.value}",
          type: "color",
          attributes: {
            figmaName: "Border/default"
          },
          description: "\u80CC\u666F\u304CWhite\u306E\u5834\u5408\u306B\u4F7F\u7528\u3059\u308B\u57FA\u672C\u306E\u30DC\u30FC\u30C0\u30FC\u306E\u8272"
        },
        name: "color-border-default",
        path: [
          "color",
          "border",
          "default"
        ]
      },
      darken: {
        value: "#e2e4e4",
        type: "color",
        attributes: {
          figmaName: "Border/darken"
        },
        description: "\u80CC\u666F\u304Cgray\u306E\u5834\u5408\u306B\u4F7F\u7528\u3059\u308B\u30DC\u30FC\u30C0\u30FC\u306E\u8272",
        filePath: "tokens/color/semantics/border.json",
        isSource: !0,
        original: {
          value: "{color.primitive.gray-40.value}",
          type: "color",
          attributes: {
            figmaName: "Border/darken"
          },
          description: "\u80CC\u666F\u304Cgray\u306E\u5834\u5408\u306B\u4F7F\u7528\u3059\u308B\u30DC\u30FC\u30C0\u30FC\u306E\u8272"
        },
        name: "color-border-darken",
        path: [
          "color",
          "border",
          "darken"
        ]
      }
    },
    button: {
      primary: {
        bgDefault: {
          value: "#4c6072",
          type: "color",
          attributes: {
            figmaName: "Button/Primary/Background/Default"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.navy-300.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Primary/Background/Default"
            }
          },
          name: "color-button-primary-bg-default",
          path: [
            "color",
            "button",
            "primary",
            "bg-default"
          ]
        },
        bgHover: {
          value: "#354350",
          type: "color",
          attributes: {
            figmaName: "Button/Primary/Background/Hover"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.navy-400.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Primary/Background/Hover"
            }
          },
          name: "color-button-primary-bg-hover",
          path: [
            "color",
            "button",
            "primary",
            "bg-hover"
          ]
        },
        bgDisabled: {
          value: "#e2e4e4",
          type: "color",
          attributes: {
            figmaName: "Button/Primary/Background/Disabled"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.gray-40.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Primary/Background/Disabled"
            }
          },
          name: "color-button-primary-bg-disabled",
          path: [
            "color",
            "button",
            "primary",
            "bg-disabled"
          ]
        },
        borderDefault: {
          value: "#4c6072",
          type: "color",
          attributes: {
            figmaName: "Button/Primary/Border/Default"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.navy-300.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Primary/Border/Default"
            }
          },
          name: "color-button-primary-border-default",
          path: [
            "color",
            "button",
            "primary",
            "border-default"
          ]
        },
        borderHover: {
          value: "#354350",
          type: "color",
          attributes: {
            figmaName: "Button/Primary/Border/Hover"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.navy-400.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Primary/Border/Hover"
            }
          },
          name: "color-button-primary-border-hover",
          path: [
            "color",
            "button",
            "primary",
            "border-hover"
          ]
        },
        borderDisabled: {
          value: "#e2e4e4",
          type: "color",
          attributes: {
            figmaName: "Button/Primary/Border/Disabled"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.gray-40.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Primary/Border/Disabled"
            }
          },
          name: "color-button-primary-border-disabled",
          path: [
            "color",
            "button",
            "primary",
            "border-disabled"
          ]
        },
        textDefault: {
          value: "#FFFFFF",
          type: "color",
          attributes: {
            figmaName: "Button/Primary/Text/Default"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.text.white.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Primary/Text/Default"
            }
          },
          name: "color-button-primary-text-default",
          path: [
            "color",
            "button",
            "primary",
            "text-default"
          ]
        },
        textDisabled: {
          value: "#c7cbcc",
          type: "color",
          attributes: {
            figmaName: "Button/Primary/Text/Disabled"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.text.disabled.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Primary/Text/Disabled"
            }
          },
          name: "color-button-primary-text-disabled",
          path: [
            "color",
            "button",
            "primary",
            "text-disabled"
          ]
        }
      },
      secondary: {
        bgHover: {
          value: "rgba(76, 96, 114, 0.1)",
          type: "color",
          attributes: {
            figmaName: "Button/Secondary/Background/Default"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "rgba(76, 96, 114, 0.1)",
            type: "color",
            attributes: {
              figmaName: "Button/Secondary/Background/Default"
            }
          },
          name: "color-button-secondary-bg-hover",
          path: [
            "color",
            "button",
            "secondary",
            "bg-hover"
          ]
        },
        borderDefault: {
          value: "#4c6072",
          type: "color",
          attributes: {
            figmaName: "Button/Secondary/Border/Default"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.navy-300.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Secondary/Border/Default"
            }
          },
          name: "color-button-secondary-border-default",
          path: [
            "color",
            "button",
            "secondary",
            "border-default"
          ]
        },
        borderDisabled: {
          value: "#c7cbcc",
          type: "color",
          attributes: {
            figmaName: "Button/Secondary/Border/Disabled"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.gray-50.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Secondary/Border/Disabled"
            }
          },
          name: "color-button-secondary-border-disabled",
          path: [
            "color",
            "button",
            "secondary",
            "border-disabled"
          ]
        },
        textDefault: {
          value: "#4c6072",
          type: "color",
          attributes: {
            figmaName: "Button/Secondary/Text/Default"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.text.primary.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Secondary/Text/Default"
            }
          },
          name: "color-button-secondary-text-default",
          path: [
            "color",
            "button",
            "secondary",
            "text-default"
          ]
        },
        textDisabled: {
          value: "#c7cbcc",
          type: "color",
          attributes: {
            figmaName: "Button/Secondary/Text/Disabled"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.text.disabled.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Secondary/Text/Disabled"
            }
          },
          name: "color-button-secondary-text-disabled",
          path: [
            "color",
            "button",
            "secondary",
            "text-disabled"
          ]
        }
      },
      danger: {
        bgDefault: {
          value: "#df5475",
          type: "color",
          attributes: {
            figmaName: "Button/Danger/Background/Default"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.red-300.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Danger/Background/Default"
            }
          },
          name: "color-button-danger-bg-default",
          path: [
            "color",
            "button",
            "danger",
            "bg-default"
          ]
        },
        bgHover: {
          value: "#C34160",
          type: "color",
          attributes: {
            figmaName: "Button/Danger/Background/Hover"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.red-350.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Danger/Background/Hover"
            }
          },
          name: "color-button-danger-bg-hover",
          path: [
            "color",
            "button",
            "danger",
            "bg-hover"
          ]
        },
        bgDisabled: {
          value: "#e2e4e4",
          type: "color",
          attributes: {
            figmaName: "Button/Danger/Background/Disabled"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.gray-40.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Danger/Background/Disabled"
            }
          },
          name: "color-button-danger-bg-disabled",
          path: [
            "color",
            "button",
            "danger",
            "bg-disabled"
          ]
        },
        borderDefault: {
          value: "#df5475",
          type: "color",
          attributes: {
            figmaName: "Button/Danger/Border/Default"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.red-300.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Danger/Border/Default"
            }
          },
          name: "color-button-danger-border-default",
          path: [
            "color",
            "button",
            "danger",
            "border-default"
          ]
        },
        borderHover: {
          value: "#C34160",
          type: "color",
          attributes: {
            figmaName: "Button/Danger/Border/Hover"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.red-350.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Danger/Border/Hover"
            }
          },
          name: "color-button-danger-border-hover",
          path: [
            "color",
            "button",
            "danger",
            "border-hover"
          ]
        },
        borderDisabled: {
          value: "#e2e4e4",
          type: "color",
          attributes: {
            figmaName: "Button/Danger/Border/Disabled"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.primitive.gray-40.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Danger/Border/Disabled"
            }
          },
          name: "color-button-danger-border-disabled",
          path: [
            "color",
            "button",
            "danger",
            "border-disabled"
          ]
        },
        textDefault: {
          value: "#FFFFFF",
          type: "color",
          attributes: {
            figmaName: "Button/Danger/Text/Default"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.text.white.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Danger/Text/Default"
            }
          },
          name: "color-button-danger-text-default",
          path: [
            "color",
            "button",
            "danger",
            "text-default"
          ]
        },
        textDisabled: {
          value: "#c7cbcc",
          type: "color",
          attributes: {
            figmaName: "Button/Danger/Text/Disabled"
          },
          filePath: "tokens/color/semantics/button.json",
          isSource: !0,
          original: {
            value: "{color.text.disabled.value}",
            type: "color",
            attributes: {
              figmaName: "Button/Danger/Text/Disabled"
            }
          },
          name: "color-button-danger-text-disabled",
          path: [
            "color",
            "button",
            "danger",
            "text-disabled"
          ]
        }
      }
    },
    function: {
      primaryDefault: {
        value: "#4c6072",
        type: "color",
        attributes: {
          figmaName: "Function/Primary/default"
        },
        filePath: "tokens/color/semantics/function.json",
        isSource: !0,
        original: {
          value: "{color.primitive.navy-300.value}",
          type: "color",
          attributes: {
            figmaName: "Function/Primary/default"
          }
        },
        name: "color-function-primary-default",
        path: [
          "color",
          "function",
          "primary-default"
        ]
      },
      dangerDefault: {
        value: "#df5475",
        type: "color",
        attributes: {
          figmaName: "Function/Danger/default"
        },
        filePath: "tokens/color/semantics/function.json",
        isSource: !0,
        original: {
          value: "{color.primitive.red-300.value}",
          type: "color",
          attributes: {
            figmaName: "Function/Danger/default"
          }
        },
        name: "color-function-danger-default",
        path: [
          "color",
          "function",
          "danger-default"
        ]
      },
      successDefault: {
        value: "#4aae42",
        type: "color",
        description: "\u6210\u529F\u7CFB\u306E\u8272",
        attributes: {
          figmaName: "Function/Success/default"
        },
        filePath: "tokens/color/semantics/function.json",
        isSource: !0,
        original: {
          value: "{color.primitive.green-300.value}",
          type: "color",
          description: "\u6210\u529F\u7CFB\u306E\u8272",
          attributes: {
            figmaName: "Function/Success/default"
          }
        },
        name: "color-function-success-default",
        path: [
          "color",
          "function",
          "success-default"
        ]
      },
      textlinkDefault: {
        value: "#2b8ade",
        type: "color",
        description: "\u30C6\u30AD\u30B9\u30C8\u30EA\u30F3\u30AF\u7528\u306E\u8272",
        attributes: {
          figmaName: "Function/TextLink/default"
        },
        filePath: "tokens/color/semantics/function.json",
        isSource: !0,
        original: {
          value: "{color.primitive.blue-300.value}",
          type: "color",
          description: "\u30C6\u30AD\u30B9\u30C8\u30EA\u30F3\u30AF\u7528\u306E\u8272",
          attributes: {
            figmaName: "Function/TextLink/default"
          }
        },
        name: "color-function-textlink-default",
        path: [
          "color",
          "function",
          "textlink-default"
        ]
      }
    },
    object: {
      shepinkLightest: {
        value: "#F2E5E5",
        type: "color",
        attributes: {
          figmaName: "Object/SHEPink/lightest"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shepink-200.value}",
          type: "color",
          attributes: {
            figmaName: "Object/SHEPink/lightest"
          }
        },
        name: "color-object-shepink-lightest",
        path: [
          "color",
          "object",
          "shepink-lightest"
        ]
      },
      shepinkLight: {
        value: "#EFD6D5",
        type: "color",
        attributes: {
          figmaName: "Object/SHEPink/light"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shepink-300.value}",
          type: "color",
          attributes: {
            figmaName: "Object/SHEPink/light"
          }
        },
        name: "color-object-shepink-light",
        path: [
          "color",
          "object",
          "shepink-light"
        ]
      },
      shepinkNormal: {
        value: "#D6A1A1",
        type: "color",
        attributes: {
          figmaName: "Object/SHEPink/normal"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shepink-400.value}",
          type: "color",
          attributes: {
            figmaName: "Object/SHEPink/normal"
          }
        },
        name: "color-object-shepink-normal",
        path: [
          "color",
          "object",
          "shepink-normal"
        ]
      },
      shepinkDarken: {
        value: "#C38383",
        type: "color",
        attributes: {
          figmaName: "Object/SHEPink/darken"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shepink-500.value}",
          type: "color",
          attributes: {
            figmaName: "Object/SHEPink/darken"
          }
        },
        name: "color-object-shepink-darken",
        path: [
          "color",
          "object",
          "shepink-darken"
        ]
      },
      sheblueLightest: {
        value: "#DFEAED",
        type: "color",
        attributes: {
          figmaName: "Object/SHEBlue/lightest"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.sheblue-200.value}",
          type: "color",
          attributes: {
            figmaName: "Object/SHEBlue/lightest"
          }
        },
        name: "color-object-sheblue-lightest",
        path: [
          "color",
          "object",
          "sheblue-lightest"
        ]
      },
      sheblueLight: {
        value: "#D7E4EA",
        type: "color",
        attributes: {
          figmaName: "Object/SHEBlue/light"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.sheblue-300.value}",
          type: "color",
          attributes: {
            figmaName: "Object/SHEBlue/light"
          }
        },
        name: "color-object-sheblue-light",
        path: [
          "color",
          "object",
          "sheblue-light"
        ]
      },
      sheblueNormal: {
        value: "#BAD1DB",
        type: "color",
        attributes: {
          figmaName: "Object/SHEBlue/normal"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.sheblue-400.value}",
          type: "color",
          attributes: {
            figmaName: "Object/SHEBlue/normal"
          }
        },
        name: "color-object-sheblue-normal",
        path: [
          "color",
          "object",
          "sheblue-normal"
        ]
      },
      sheblueDarken: {
        value: "#6B9BAA",
        type: "color",
        attributes: {
          figmaName: "Object/SHEBlue/darken"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.sheblue-500.value}",
          type: "color",
          attributes: {
            figmaName: "Object/SHEBlue/darken"
          }
        },
        name: "color-object-sheblue-darken",
        path: [
          "color",
          "object",
          "sheblue-darken"
        ]
      },
      shegreenLightest: {
        value: "#E6EFED",
        type: "color",
        attributes: {
          figmaName: "Object/SHEGreen/lightest"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shegreen-200.value}",
          type: "color",
          attributes: {
            figmaName: "Object/SHEGreen/lightest"
          }
        },
        name: "color-object-shegreen-lightest",
        path: [
          "color",
          "object",
          "shegreen-lightest"
        ]
      },
      shegreenLight: {
        value: "#CFE0DC",
        type: "color",
        attributes: {
          figmaName: "Object/SHEGreen/light"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shegreen-300.value}",
          type: "color",
          attributes: {
            figmaName: "Object/SHEGreen/light"
          }
        },
        name: "color-object-shegreen-light",
        path: [
          "color",
          "object",
          "shegreen-light"
        ]
      },
      shegreenNormal: {
        value: "#97B7B6",
        type: "color",
        attributes: {
          figmaName: "Object/SHEGreen/normal"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shegreen-400.value}",
          type: "color",
          attributes: {
            figmaName: "Object/SHEGreen/normal"
          }
        },
        name: "color-object-shegreen-normal",
        path: [
          "color",
          "object",
          "shegreen-normal"
        ]
      },
      shegreenDarken: {
        value: "#729897",
        type: "color",
        attributes: {
          figmaName: "Object/SHEGreen/darken"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shegreen-500.value}",
          type: "color",
          attributes: {
            figmaName: "Object/SHEGreen/darken"
          }
        },
        name: "color-object-shegreen-darken",
        path: [
          "color",
          "object",
          "shegreen-darken"
        ]
      },
      gray1: {
        value: "#f6f7f7",
        type: "color",
        attributes: {
          figmaName: "Object/Gray/1"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.gray-20.value}",
          type: "color",
          attributes: {
            figmaName: "Object/Gray/1"
          }
        },
        name: "color-object-gray-1",
        path: [
          "color",
          "object",
          "gray-1"
        ]
      },
      gray2: {
        value: "#e2e4e4",
        type: "color",
        attributes: {
          figmaName: "Object/Gray/2"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.gray-40.value}",
          type: "color",
          attributes: {
            figmaName: "Object/Gray/2"
          }
        },
        name: "color-object-gray-2",
        path: [
          "color",
          "object",
          "gray-2"
        ]
      },
      gray3: {
        value: "#c7cbcc",
        type: "color",
        description: "ex. disabled\u3084\u30A2\u30AF\u30C6\u30A3\u30D6\u3067\u306F\u306A\u3044\u8981\u7D20",
        attributes: {
          figmaName: "Object/Gray/3"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.gray-50.value}",
          type: "color",
          description: "ex. disabled\u3084\u30A2\u30AF\u30C6\u30A3\u30D6\u3067\u306F\u306A\u3044\u8981\u7D20",
          attributes: {
            figmaName: "Object/Gray/3"
          }
        },
        name: "color-object-gray-3",
        path: [
          "color",
          "object",
          "gray-3"
        ]
      },
      gray4: {
        value: "#a1a7a9",
        type: "color",
        description: "ex. disabled\u3067\u306F\u306A\u3044\u304C\u30B0\u30EC\u30FC\u306E\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u3092\u4E57\u305B\u305F\u3044\u5834\u5408\u306E\u8272",
        attributes: {
          figmaName: "Object/Gray/4"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.gray-80.value}",
          type: "color",
          description: "ex. disabled\u3067\u306F\u306A\u3044\u304C\u30B0\u30EC\u30FC\u306E\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u3092\u4E57\u305B\u305F\u3044\u5834\u5408\u306E\u8272",
          attributes: {
            figmaName: "Object/Gray/4"
          }
        },
        name: "color-object-gray-4",
        path: [
          "color",
          "object",
          "gray-4"
        ]
      },
      white: {
        value: "#FFFFFF",
        type: "color",
        attributes: {
          figmaName: "Object/White"
        },
        filePath: "tokens/color/semantics/object.json",
        isSource: !0,
        original: {
          value: "{color.primitive.white.value}",
          type: "color",
          attributes: {
            figmaName: "Object/White"
          }
        },
        name: "color-object-white",
        path: [
          "color",
          "object",
          "white"
        ]
      }
    },
    overlay: {
      default: {
        value: "rgba(207, 215, 226, 0.72)",
        type: "color",
        description: "\u57FA\u672C\u306E\u30AA\u30FC\u30D0\u30FC\u30EC\u30A4\u306E\u8272",
        attributes: {
          figmaName: "Overlay/default"
        },
        filePath: "tokens/color/semantics/overlay.json",
        isSource: !0,
        original: {
          value: "rgba(207, 215, 226, 0.72)",
          type: "color",
          description: "\u57FA\u672C\u306E\u30AA\u30FC\u30D0\u30FC\u30EC\u30A4\u306E\u8272",
          attributes: {
            figmaName: "Overlay/default"
          }
        },
        name: "color-overlay-default",
        path: [
          "color",
          "overlay",
          "default"
        ]
      }
    },
    text: {
      white: {
        value: "#FFFFFF",
        type: "color",
        attributes: {
          figmaName: "Text/white"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.white.value}",
          type: "color",
          attributes: {
            figmaName: "Text/white"
          }
        },
        name: "color-text-white",
        path: [
          "color",
          "text",
          "white"
        ]
      },
      default: {
        value: "#1F2D32",
        type: "color",
        attributes: {
          figmaName: "Text/default"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.black.value}",
          type: "color",
          attributes: {
            figmaName: "Text/default"
          }
        },
        name: "color-text-default",
        path: [
          "color",
          "text",
          "default"
        ]
      },
      lightest: {
        value: "#849194",
        type: "color",
        attributes: {
          figmaName: "Text/lightest"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.gray-100.value}",
          type: "color",
          attributes: {
            figmaName: "Text/lightest"
          }
        },
        name: "color-text-lightest",
        path: [
          "color",
          "text",
          "lightest"
        ]
      },
      light: {
        value: "#4c6072",
        type: "color",
        attributes: {
          figmaName: "Text/light"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.navy-300.value}",
          type: "color",
          attributes: {
            figmaName: "Text/light"
          }
        },
        name: "color-text-light",
        path: [
          "color",
          "text",
          "light"
        ]
      },
      disabled: {
        value: "#c7cbcc",
        type: "color",
        attributes: {
          figmaName: "Text/disabled"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.gray-50.value}",
          type: "color",
          attributes: {
            figmaName: "Text/disabled"
          }
        },
        name: "color-text-disabled",
        path: [
          "color",
          "text",
          "disabled"
        ]
      },
      danger: {
        value: "#df5475",
        type: "color",
        attributes: {
          figmaName: "Text/danger"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.red-300.value}",
          type: "color",
          attributes: {
            figmaName: "Text/danger"
          }
        },
        name: "color-text-danger",
        path: [
          "color",
          "text",
          "danger"
        ]
      },
      primary: {
        value: "#4c6072",
        type: "color",
        attributes: {
          figmaName: "Text/primary"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.navy-300.value}",
          type: "color",
          attributes: {
            figmaName: "Text/primary"
          }
        },
        name: "color-text-primary",
        path: [
          "color",
          "text",
          "primary"
        ]
      },
      shepinkDefault: {
        value: "#C38383",
        type: "color",
        attributes: {
          figmaName: "Text/SHEPink/default"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shepink-500.value}",
          type: "color",
          attributes: {
            figmaName: "Text/SHEPink/default"
          }
        },
        name: "color-text-shepink-default",
        path: [
          "color",
          "text",
          "shepink-default"
        ]
      },
      shepinkDarken: {
        value: "#BA7D7D",
        type: "color",
        attributes: {
          figmaName: "Text/SHEPink/darken"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shepink-600.value}",
          type: "color",
          attributes: {
            figmaName: "Text/SHEPink/darken"
          }
        },
        name: "color-text-shepink-darken",
        path: [
          "color",
          "text",
          "shepink-darken"
        ]
      },
      sheblueDefault: {
        value: "#6B9BAA",
        type: "color",
        attributes: {
          figmaName: "Text/SHEBlue/default"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.sheblue-500.value}",
          type: "color",
          attributes: {
            figmaName: "Text/SHEBlue/default"
          }
        },
        name: "color-text-sheblue-default",
        path: [
          "color",
          "text",
          "sheblue-default"
        ]
      },
      sheblueDarken: {
        value: "#4D8193",
        type: "color",
        attributes: {
          figmaName: "Text/SHEBlue/darken"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.sheblue-600.value}",
          type: "color",
          attributes: {
            figmaName: "Text/SHEBlue/darken"
          }
        },
        name: "color-text-sheblue-darken",
        path: [
          "color",
          "text",
          "sheblue-darken"
        ]
      },
      shegreenDefault: {
        value: "#729897",
        type: "color",
        attributes: {
          figmaName: "Text/SHEGreen/default"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shegreen-500.value}",
          type: "color",
          attributes: {
            figmaName: "Text/SHEGreen/default"
          }
        },
        name: "color-text-shegreen-default",
        path: [
          "color",
          "text",
          "shegreen-default"
        ]
      },
      shegreenDarken: {
        value: "#3E6770",
        type: "color",
        attributes: {
          figmaName: "Text/SHEGreen/darken"
        },
        filePath: "tokens/color/semantics/text.json",
        isSource: !0,
        original: {
          value: "{color.primitive.shegreen-600.value}",
          type: "color",
          attributes: {
            figmaName: "Text/SHEGreen/darken"
          }
        },
        name: "color-text-shegreen-darken",
        path: [
          "color",
          "text",
          "shegreen-darken"
        ]
      }
    }
  },
  fontSize: {
    250: {
      value: "0.625rem",
      attributes: {
        px: "10"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "0.625rem",
        attributes: {
          px: "10"
        }
      },
      name: "font-size-250",
      path: [
        "font-size",
        "250"
      ]
    },
    300: {
      value: "0.75rem",
      attributes: {
        px: "12"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "0.75rem",
        attributes: {
          px: "12"
        }
      },
      name: "font-size-300",
      path: [
        "font-size",
        "300"
      ]
    },
    350: {
      value: "0.875rem",
      attributes: {
        px: "14"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "0.875rem",
        attributes: {
          px: "14"
        }
      },
      name: "font-size-350",
      path: [
        "font-size",
        "350"
      ]
    },
    400: {
      value: "1rem",
      attributes: {
        px: "16"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "1rem",
        attributes: {
          px: "16"
        }
      },
      name: "font-size-400",
      path: [
        "font-size",
        "400"
      ]
    },
    450: {
      value: "1.125rem",
      attributes: {
        px: "18"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "1.125rem",
        attributes: {
          px: "18"
        }
      },
      name: "font-size-450",
      path: [
        "font-size",
        "450"
      ]
    },
    500: {
      value: "1.25rem",
      attributes: {
        px: "20"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "1.25rem",
        attributes: {
          px: "20"
        }
      },
      name: "font-size-500",
      path: [
        "font-size",
        "500"
      ]
    },
    550: {
      value: "1.375rem",
      attributes: {
        px: "22"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "1.375rem",
        attributes: {
          px: "22"
        }
      },
      name: "font-size-550",
      path: [
        "font-size",
        "550"
      ]
    },
    600: {
      value: "1.5rem",
      attributes: {
        px: "24"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "1.5rem",
        attributes: {
          px: "24"
        }
      },
      name: "font-size-600",
      path: [
        "font-size",
        "600"
      ]
    },
    650: {
      value: "1.625rem",
      attributes: {
        px: "26"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "1.625rem",
        attributes: {
          px: "26"
        }
      },
      name: "font-size-650",
      path: [
        "font-size",
        "650"
      ]
    },
    700: {
      value: "1.75rem",
      attributes: {
        px: "28"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "1.75rem",
        attributes: {
          px: "28"
        }
      },
      name: "font-size-700",
      path: [
        "font-size",
        "700"
      ]
    },
    750: {
      value: "1.875rem",
      attributes: {
        px: "30"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "1.875rem",
        attributes: {
          px: "30"
        }
      },
      name: "font-size-750",
      path: [
        "font-size",
        "750"
      ]
    },
    800: {
      value: "2rem",
      attributes: {
        px: "32"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "2rem",
        attributes: {
          px: "32"
        }
      },
      name: "font-size-800",
      path: [
        "font-size",
        "800"
      ]
    },
    850: {
      value: "2.125rem",
      attributes: {
        px: "34"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "2.125rem",
        attributes: {
          px: "34"
        }
      },
      name: "font-size-850",
      path: [
        "font-size",
        "850"
      ]
    },
    900: {
      value: "2.25rem",
      attributes: {
        px: "36"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "2.25rem",
        attributes: {
          px: "36"
        }
      },
      name: "font-size-900",
      path: [
        "font-size",
        "900"
      ]
    },
    950: {
      value: "2.375rem",
      attributes: {
        px: "38"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "2.375rem",
        attributes: {
          px: "38"
        }
      },
      name: "font-size-950",
      path: [
        "font-size",
        "950"
      ]
    },
    1e3: {
      value: "2.5rem",
      attributes: {
        px: "40"
      },
      filePath: "tokens/font-size/font-size.json",
      isSource: !0,
      original: {
        value: "2.5rem",
        attributes: {
          px: "40"
        }
      },
      name: "font-size-1000",
      path: [
        "font-size",
        "1000"
      ]
    }
  },
  fontFamily: {
    default: {
      value: "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Hiragino Sans',Meiryo,sans-serif,'Segoe UI Emoji'",
      filePath: "tokens/fontfamily/fontfamily.json",
      isSource: !0,
      original: {
        value: "-apple-system,'BlinkMacSystemFont','Hiragino Kaku Gothic ProN','Hiragino Sans',Meiryo,sans-serif,'Segoe UI Emoji'"
      },
      name: "font-family-default",
      attributes: {},
      path: [
        "font-family",
        "default:"
      ]
    }
  },
  space: {
    100: {
      value: "0.25rem",
      attributes: {
        px: "4"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "0.25rem",
        attributes: {
          px: "4"
        }
      },
      name: "space-100",
      path: [
        "space",
        "100"
      ]
    },
    150: {
      value: "0.375rem",
      attributes: {
        px: "6"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "0.375rem",
        attributes: {
          px: "6"
        }
      },
      name: "space-150",
      path: [
        "space",
        "150"
      ]
    },
    200: {
      value: "0.5rem",
      attributes: {
        px: "8"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "0.5rem",
        attributes: {
          px: "8"
        }
      },
      name: "space-200",
      path: [
        "space",
        "200"
      ]
    },
    250: {
      value: "0.625rem",
      attributes: {
        px: "10"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "0.625rem",
        attributes: {
          px: "10"
        }
      },
      name: "space-250",
      path: [
        "space",
        "250"
      ]
    },
    300: {
      value: "0.75rem",
      attributes: {
        px: "12"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "0.75rem",
        attributes: {
          px: "12"
        }
      },
      name: "space-300",
      path: [
        "space",
        "300"
      ]
    },
    350: {
      value: "0.875rem",
      attributes: {
        px: "14"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "0.875rem",
        attributes: {
          px: "14"
        }
      },
      name: "space-350",
      path: [
        "space",
        "350"
      ]
    },
    400: {
      value: "1rem",
      attributes: {
        px: "16"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "1rem",
        attributes: {
          px: "16"
        }
      },
      name: "space-400",
      path: [
        "space",
        "400"
      ]
    },
    500: {
      value: "1.25rem",
      attributes: {
        px: "20"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "1.25rem",
        attributes: {
          px: "20"
        }
      },
      name: "space-500",
      path: [
        "space",
        "500"
      ]
    },
    600: {
      value: "1.5rem",
      attributes: {
        px: "24"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "1.5rem",
        attributes: {
          px: "24"
        }
      },
      name: "space-600",
      path: [
        "space",
        "600"
      ]
    },
    700: {
      value: "1.75rem",
      attributes: {
        px: "28"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "1.75rem",
        attributes: {
          px: "28"
        }
      },
      name: "space-700",
      path: [
        "space",
        "700"
      ]
    },
    800: {
      value: "2rem",
      attributes: {
        px: "32"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "2rem",
        attributes: {
          px: "32"
        }
      },
      name: "space-800",
      path: [
        "space",
        "800"
      ]
    },
    900: {
      value: "2.25rem",
      attributes: {
        px: "36"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "2.25rem",
        attributes: {
          px: "36"
        }
      },
      name: "space-900",
      path: [
        "space",
        "900"
      ]
    },
    1e3: {
      value: "2.5rem",
      attributes: {
        px: "40"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "2.5rem",
        attributes: {
          px: "40"
        }
      },
      name: "space-1000",
      path: [
        "space",
        "1000"
      ]
    },
    1200: {
      value: "3rem",
      attributes: {
        px: "48"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "3rem",
        attributes: {
          px: "48"
        }
      },
      name: "space-1200",
      path: [
        "space",
        "1200"
      ]
    },
    1400: {
      value: "3.5rem",
      attributes: {
        px: "56"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "3.5rem",
        attributes: {
          px: "56"
        }
      },
      name: "space-1400",
      path: [
        "space",
        "1400"
      ]
    },
    1600: {
      value: "4rem",
      attributes: {
        px: "64"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "4rem",
        attributes: {
          px: "64"
        }
      },
      name: "space-1600",
      path: [
        "space",
        "1600"
      ]
    },
    2e3: {
      value: "5rem",
      attributes: {
        px: "80"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "5rem",
        attributes: {
          px: "80"
        }
      },
      name: "space-2000",
      path: [
        "space",
        "2000"
      ]
    },
    2400: {
      value: "6rem",
      attributes: {
        px: "96"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "6rem",
        attributes: {
          px: "96"
        }
      },
      name: "space-2400",
      path: [
        "space",
        "2400"
      ]
    },
    "050": {
      value: "0.125rem",
      attributes: {
        px: "2"
      },
      filePath: "tokens/spacing/spacing.json",
      isSource: !0,
      original: {
        value: "0.125rem",
        attributes: {
          px: "2"
        }
      },
      name: "space-050",
      path: [
        "space",
        "050"
      ]
    }
  },
  zindex: {
    hide: {
      value: "-1",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "-1"
      },
      name: "zindex-hide",
      attributes: {},
      path: [
        "zindex",
        "hide:"
      ]
    },
    auto: {
      value: "'auto'",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "'auto'"
      },
      name: "zindex-auto",
      attributes: {},
      path: [
        "zindex",
        "auto:"
      ]
    },
    base: {
      value: "0",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "0"
      },
      name: "zindex-base",
      attributes: {},
      path: [
        "zindex",
        "base:"
      ]
    },
    docked: {
      value: "10",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "10"
      },
      name: "zindex-docked",
      attributes: {},
      path: [
        "zindex",
        "docked:"
      ]
    },
    dropdown: {
      value: "1000",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "1000"
      },
      name: "zindex-dropdown",
      attributes: {},
      path: [
        "zindex",
        "dropdown:"
      ]
    },
    sticky: {
      value: "1100",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "1100"
      },
      name: "zindex-sticky",
      attributes: {},
      path: [
        "zindex",
        "sticky:"
      ]
    },
    banner: {
      value: "1200",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "1200"
      },
      name: "zindex-banner",
      attributes: {},
      path: [
        "zindex",
        "banner:"
      ]
    },
    overlay: {
      value: "1300",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "1300"
      },
      name: "zindex-overlay",
      attributes: {},
      path: [
        "zindex",
        "overlay:"
      ]
    },
    modal: {
      value: "1400",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "1400"
      },
      name: "zindex-modal",
      attributes: {},
      path: [
        "zindex",
        "modal:"
      ]
    },
    popover: {
      value: "1500",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "1500"
      },
      name: "zindex-popover",
      attributes: {},
      path: [
        "zindex",
        "popover:"
      ]
    },
    skipLink: {
      value: "1600",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "1600"
      },
      name: "zindex-skip-link",
      attributes: {},
      path: [
        "zindex",
        "skipLink:"
      ]
    },
    toast: {
      value: "1700",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "1700"
      },
      name: "zindex-toast",
      attributes: {},
      path: [
        "zindex",
        "toast:"
      ]
    },
    tooltip: {
      value: "1800",
      filePath: "tokens/zindex/zindex.json",
      isSource: !0,
      original: {
        value: "1800"
      },
      name: "zindex-tooltip",
      attributes: {},
      path: [
        "zindex",
        "tooltip:"
      ]
    }
  }
};
var Sr = "Tooltip_3_1_3_7h1l8p0", kr = { top: "Tooltip_3_1_3_7h1l8p1", topRight: "Tooltip_3_1_3_7h1l8p2", right: "Tooltip_3_1_3_7h1l8p3", bottomRight: "Tooltip_3_1_3_7h1l8p4", bottom: "Tooltip_3_1_3_7h1l8p5", bottomLeft: "Tooltip_3_1_3_7h1l8p6", left: "Tooltip_3_1_3_7h1l8p7", topLeft: "Tooltip_3_1_3_7h1l8p8" };
const Pr = ({ direction: e = "top", text: t, testId: a, children: r, ...o }) => /* @__PURE__ */ i.createElement(
  "span",
  {
    className: b(Sr, kr[e]),
    role: "tooltip",
    "aria-label": t,
    "data-testid": a,
    ...o
  },
  r
), Me = ({
  id: e,
  label: t,
  help: a,
  error: r,
  layout: o = "vertical",
  required: n,
  optional: l,
  info: s,
  testId: u,
  children: f,
  htmlFor: m
}) => {
  const d = H(() => !!r, [r]), g = H(() => !!a && !d, [d, a]);
  return /* @__PURE__ */ i.createElement("div", { "data-testid": u }, /* @__PURE__ */ i.createElement("div", { className: gr[o] }, t && /* @__PURE__ */ i.createElement("label", { className: b(yr[o]), htmlFor: m, id: e }, /* @__PURE__ */ i.createElement(le, { size: "M", weight: "bold" }, t), s && /* @__PURE__ */ i.createElement(Pr, { "aria-label": s }, /* @__PURE__ */ i.createElement(xt, { color: ie.color.function.primaryDefault.value })), n || l ? /* @__PURE__ */ i.createElement(dr, { required: n }, n ? "\u5FC5\u9808" : "\u4EFB\u610F") : null), /* @__PURE__ */ i.createElement("div", { className: br[o] }, f)), (g || d) && /* @__PURE__ */ i.createElement("div", { className: hr[o] }, g && /* @__PURE__ */ i.createElement(Ge, null, a), /* @__PURE__ */ i.createElement(He, { show: d }, r)));
};
var xr = "TextInput_3_1_3_1vrk2t80", Er = "TextInput_3_1_3_1vrk2t81", jr = "TextInput_3_1_3_1vrk2t82", Nr = "TextInput_3_1_3_1vrk2t83";
let Br = 0;
const J = () => `shelikes-design-system-${Br++}`, wr = oe(
  ({ label: e, help: t, error: a, layout: r = "vertical", required: o, optional: n, disabled: l, testId: s, ...u }, f) => {
    const m = l ? jr : a ? Nr : Er, d = H(() => u.id || J(), [u.id]);
    return /* @__PURE__ */ i.createElement(
      Me,
      {
        htmlFor: d,
        label: e,
        help: t,
        error: a,
        layout: r,
        required: o,
        optional: n,
        testId: s
      },
      /* @__PURE__ */ i.createElement(
        "input",
        {
          id: d,
          ref: f,
          type: "text",
          className: b(xr, m),
          required: o,
          disabled: l,
          ...u
        }
      )
    );
  }
);
wr.displayName = "TextInput";
var Tr = "TextInputGroup_3_1_3_exj39b0", zr = { S: "TextInputGroup_3_1_3_exj39b1", M: "TextInputGroup_3_1_3_exj39b2" };
const Bi = ({ children: e, testId: t, gapSize: a = "M" }) => /* @__PURE__ */ i.createElement("div", { className: b(zr[a], Tr), "data-testid": t }, e);
var Fr = "Textarea_3_1_3_1903ywp0", Cr = "Textarea_3_1_3_1903ywp1", Or = "Textarea_3_1_3_1903ywp2", Dr = "Textarea_3_1_3_1903ywp3";
const Lr = oe(
  ({ label: e, help: t, error: a, layout: r = "vertical", required: o, disabled: n, testId: l, ...s }, u) => {
    const f = n ? Or : a ? Dr : Cr, m = H(() => s.id || J(), [s.id]);
    return /* @__PURE__ */ i.createElement(
      Me,
      {
        htmlFor: m,
        label: e,
        help: t,
        error: a,
        layout: r,
        required: o,
        testId: l
      },
      /* @__PURE__ */ i.createElement(
        "textarea",
        {
          id: m,
          ref: u,
          className: b(Fr, f),
          required: o,
          disabled: n,
          ...s
        }
      )
    );
  }
);
Lr.displayName = "Textarea";
var Rr = "Select_3_1_3_ocrnn61", Hr = "Select_3_1_3_ocrnn63", Gr = "Select_3_1_3_ocrnn64", Mr = "Select_3_1_3_ocrnn65", Ar = "Select_3_1_3_ocrnn66", Ir = "Select_3_1_3_ocrnn62", $r = "Select_3_1_3_ocrnn60";
const et = "", wi = ({
  value: e,
  placeholder: t,
  options: a = [],
  label: r,
  help: o,
  error: n,
  layout: l = "vertical",
  required: s,
  optional: u,
  disabled: f,
  testId: m,
  onChange: d,
  ...g
}) => {
  const y = H(() => a.map((D) => ({ ...D, key: J() })), [a]), O = H(() => t && e === et, [e, t]), B = f ? Gr : n ? Mr : Hr, C = H(() => g.id || J(), [g.id]), L = V(
    (D) => {
      d == null || d(D.target.value);
    },
    [d]
  );
  return /* @__PURE__ */ i.createElement(
    Me,
    {
      htmlFor: C,
      label: r,
      help: o,
      error: n,
      layout: l,
      required: s,
      optional: u,
      testId: m
    },
    /* @__PURE__ */ i.createElement("div", { className: $r }, /* @__PURE__ */ i.createElement(
      "select",
      {
        id: C,
        className: b(Rr, B, O && Ir),
        value: e,
        required: s,
        disabled: f,
        onChange: L,
        ...g
      },
      t && /* @__PURE__ */ i.createElement("option", { value: et }, t),
      y.map((D) => /* @__PURE__ */ i.createElement("option", { key: D.key, value: D.value }, D.label))
    ), /* @__PURE__ */ i.createElement(
      Pt,
      {
        className: Ar,
        size: 24,
        color: f || n ? ie.color.primitive.sheblue600.value : ie.color.text.default.value
      }
    ))
  );
};
var Yr = "Frame_3_1_3_15dkir0", qr = "Frame_3_1_3_15dkir1", Wr = "Frame_3_1_3_15dkir4", Ur = "Frame_3_1_3_15dkir3", Jr = "Frame_3_1_3_15dkir2";
const lt = ({ children: e, type: t = "default", testId: a }) => {
  const r = H(() => {
    switch (t) {
      case "focused":
        return Jr;
      case "disabled":
        return Wr;
      case "error":
        return Ur;
      default:
        return qr;
    }
  }, [t]);
  return /* @__PURE__ */ i.createElement("div", { className: b(Yr, r), "data-testid": a }, e);
};
var Xr = "Checkbox_3_1_3_1w69k4t8", Kr = "Checkbox_3_1_3_1w69k4t3", Vr = "Checkbox_3_1_3_1w69k4t4", Qr = "Checkbox_3_1_3_1w69k4t6", Zr = "Checkbox_3_1_3_1w69k4t2", ea = "Checkbox_3_1_3_1w69k4t5", ta = "Checkbox_3_1_3_1w69k4t7", ra = "Checkbox_3_1_3_1w69k4t1", aa = "Checkbox_3_1_3_1w69k4t9", ia = "Checkbox_3_1_3_1w69k4t0";
const oa = oe(
  ({ frame: e, label: t, help: a, error: r, disabled: o, testId: n, ...l }, s) => {
    const u = H(() => J(), []), [f, m] = tt(!1), d = V(
      (D) => {
        var z;
        m(!0), (z = l.onFocus) == null || z.call(l, D);
      },
      [m]
    ), g = V(
      (D) => {
        var z;
        m(!1), (z = l.onBlur) == null || z.call(l, D);
      },
      [m]
    ), y = H(() => typeof r == "string", [r]), O = H(() => !!a && !y, [y, a]), B = H(() => o ? Qr : r ? ea : Vr, [o, r]), C = /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(
      "input",
      {
        ref: s,
        ...l,
        type: "checkbox",
        className: aa,
        id: u,
        disabled: o,
        onFocus: d,
        onBlur: g
      }
    ), /* @__PURE__ */ i.createElement("label", { className: b(ra, o && Zr), htmlFor: u }, /* @__PURE__ */ i.createElement("span", { className: b(Kr, B) }, /* @__PURE__ */ i.createElement(ht, { className: ta })), t && /* @__PURE__ */ i.createElement(le, { size: "M", color: o ? "disabled" : "default" }, t)), /* @__PURE__ */ i.createElement("div", { className: Xr }, O && /* @__PURE__ */ i.createElement(Ge, null, a), /* @__PURE__ */ i.createElement(He, { show: y }, r)));
    if (!e)
      return /* @__PURE__ */ i.createElement("div", { className: b(ia), "data-testid": n }, C);
    const L = (() => f ? "focused" : r ? "error" : o ? "disabled" : "default")();
    return /* @__PURE__ */ i.createElement(lt, { type: L, testId: n }, C);
  }
);
oa.displayName = "Checkbox";
var na = { M: "CheckboxGroup_3_1_3_r79ipq2", L: "CheckboxGroup_3_1_3_r79ipq3" }, la = "CheckboxGroup_3_1_3_r79ipq0", sa = "CheckboxGroup_3_1_3_r79ipq1";
const Ti = ({ horizontal: e, children: t, testId: a, gapSize: r = "M" }) => {
  const o = e ? la : sa;
  return /* @__PURE__ */ i.createElement("div", { className: b(o, na[r]), "data-testid": a }, t);
};
var ca = "Radio_3_1_3_nqx14u6", ua = "Radio_3_1_3_nqx14u3", ma = "Radio_3_1_3_nqx14u2", pa = "Radio_3_1_3_nqx14u5", fa = "Radio_3_1_3_nqx14u4", va = "Radio_3_1_3_nqx14u1", _a = "Radio_3_1_3_nqx14u7", da = "Radio_3_1_3_nqx14u0";
const ga = oe(
  ({ frame: e, label: t, help: a, error: r, disabled: o, testId: n, ...l }, s) => {
    const u = H(() => J(), []), [f, m] = tt(!1), d = V(
      (D) => {
        var z;
        m(!0), (z = l.onFocus) == null || z.call(l, D);
      },
      [m]
    ), g = V(
      (D) => {
        var z;
        m(!1), (z = l.onBlur) == null || z.call(l, D);
      },
      [m]
    ), y = H(() => typeof r == "string", [r]), O = H(() => !!a && !y, [y, a]), B = H(() => {
      if (o)
        return pa;
      if (r)
        return fa;
    }, [o, r]), C = /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(
      "input",
      {
        ref: s,
        ...l,
        type: "radio",
        className: _a,
        id: u,
        disabled: o,
        onFocus: d,
        onBlur: g
      }
    ), /* @__PURE__ */ i.createElement("label", { className: b(va, o && ma), htmlFor: u }, /* @__PURE__ */ i.createElement("span", { className: b(ua, B) }), t && /* @__PURE__ */ i.createElement(le, { size: "M", color: o ? "disabled" : "default" }, t)), /* @__PURE__ */ i.createElement("div", { className: ca }, O && /* @__PURE__ */ i.createElement(Ge, null, a), /* @__PURE__ */ i.createElement(He, { show: y }, r)));
    if (!e)
      return /* @__PURE__ */ i.createElement("div", { className: b(da), "data-testid": n }, C);
    const L = (() => f ? "focused" : r ? "error" : o ? "disabled" : "default")();
    return /* @__PURE__ */ i.createElement(lt, { type: L, testId: n }, C);
  }
);
ga.displayName = "Radio";
var ba = { M: "RadioGroup_3_1_3_sl6n1u2", L: "RadioGroup_3_1_3_sl6n1u3" }, ha = "RadioGroup_3_1_3_sl6n1u0", ya = "RadioGroup_3_1_3_sl6n1u1";
const zi = ({ horizontal: e, children: t, testId: a, gapSize: r = "M" }) => {
  const o = e ? ha : ya;
  return /* @__PURE__ */ i.createElement("div", { className: b(o, ba[r]), "data-testid": a }, t);
};
var Sa = "Link_3_1_3_1iqmcgo0", ka = { default: "Link_3_1_3_1iqmcgo5", lightest: "Link_3_1_3_1iqmcgo6", white: "Link_3_1_3_1iqmcgo7" }, Pa = { XS: "Link_3_1_3_1iqmcgo1", S: "Link_3_1_3_1iqmcgo2", M: "Link_3_1_3_1iqmcgo3", L: "Link_3_1_3_1iqmcgo4" };
const Fi = (e) => {
  const { as: t = "a", size: a = "M", color: r = "default", external: o = !1, testId: n, children: l, ...s } = e;
  return /* @__PURE__ */ i.createElement(
    t,
    {
      ...s,
      target: o ? "_blank" : void 0,
      rel: o ? "noopener" : void 0,
      className: b(Sa, Pa[a], ka[r]),
      "data-testid": n
    },
    l
  );
};
var xa = "CloseButton_3_1_3_1yc9z7x0", Ea = "CloseButton_3_1_3_1yc9z7x1", ja = { S: "CloseButton_3_1_3_1yc9z7x2", M: "CloseButton_3_1_3_1yc9z7x3" };
const Na = ({ onClick: e, border: t = !1, size: a = "S" }) => {
  const r = a === "S" ? 24 : 40;
  return /* @__PURE__ */ i.createElement("div", { onClick: e, className: b(xa, ja[a], t && Ea) }, /* @__PURE__ */ i.createElement(kt, { color: ie.color.button.secondary.textDefault.value, size: r, "aria-label": "\u9589\u3058\u308B" }));
};
var Ba = "Overlay_3_1_3_1j7y8l00";
const wa = ({ onClick: e }) => /* @__PURE__ */ i.createElement("div", { className: b(Ba), onClick: e });
var Ta = "ModalContent_3_1_3_jexnx20", za = { S: "ModalContent_3_1_3_jexnx21", M: "ModalContent_3_1_3_jexnx22", L: "ModalContent_3_1_3_jexnx23" };
const Fa = ({ children: e, size: t = "M" }) => /* @__PURE__ */ i.createElement("div", { className: b(Ta, za[t]) }, e);
var Ca = "Modal_3_1_3_1f9ygae3", Oa = "Modal_3_1_3_1f9ygae0", Da = "Modal_3_1_3_1f9ygae4", La = "Modal_3_1_3_1f9ygae2", Ra = "Modal_3_1_3_1f9ygae1";
const st = ({
  open: e,
  onClose: t,
  backgroundContent: a,
  children: r,
  size: o = "M",
  showOutsideCloseButton: n = !1,
  testId: l
}) => {
  const s = H(() => {
    if (n)
      return Ra;
  }, [n]);
  return /* @__PURE__ */ i.createElement(i.Fragment, null, e && /* @__PURE__ */ i.createElement("div", { className: b(Oa, s, { open: e }), "data-testid": l }, /* @__PURE__ */ i.createElement(wa, { onClick: t }), a && /* @__PURE__ */ i.createElement("div", { className: Ca }, a), /* @__PURE__ */ i.createElement("div", { className: Da }, /* @__PURE__ */ i.createElement(Fa, { size: o }, r)), n && /* @__PURE__ */ i.createElement("div", { className: La }, /* @__PURE__ */ i.createElement(xe, { size: "small", variant: "secondary", onClick: t }, "\u9589\u3058\u308B"))));
};
var Ha = "ModalHeader_3_1_3_4okmdo0";
var Ga = "ModalCloseButton_3_1_3_1ozo5ag0";
const Ma = ({ onClick: e }) => /* @__PURE__ */ i.createElement("button", { className: b(Ga) }, /* @__PURE__ */ i.createElement(Na, { onClick: e })), Aa = ({ children: e, showCloseButton: t, onClose: a }) => /* @__PURE__ */ i.createElement("div", { className: b(Ha) }, /* @__PURE__ */ i.createElement(Re, { size: "M" }, e), t && a && /* @__PURE__ */ i.createElement(Ma, { onClick: a }));
var Ia = "ModalBody_3_1_3_dthkmr0";
const ct = ({ children: e }) => /* @__PURE__ */ i.createElement("div", { className: b(Ia) }, e);
var $a = { left: "ModalFooter_3_1_3_jrca7z1", center: "ModalFooter_3_1_3_jrca7z2", right: "ModalFooter_3_1_3_jrca7z3" }, Ya = "ModalFooter_3_1_3_jrca7z0", qa = { column: "ModalFooter_3_1_3_jrca7z4", row: "ModalFooter_3_1_3_jrca7z5" }, Wa = "ModalFooter_3_1_3_jrca7z6";
const ut = ({ children: e, align: t = "right", direction: a = "row", fixed: r = !1 }) => /* @__PURE__ */ i.createElement("div", { className: b(Ya, $a[t], qa[a], { [Wa]: r }) }, e), Ci = (e) => {
  const {
    open: t,
    onClose: a,
    size: r = "M",
    title: o,
    description: n,
    confirmationButtonLabel: l = "\u78BA\u5B9A\u3059\u308B",
    confirmationButtonVariant: s = "primary",
    loadingConfirmationButton: u,
    disabledConfirmationButton: f,
    onClickConfirm: m,
    showCloseButton: d = !0,
    footerFixed: g = !1,
    children: y,
    testId: O
  } = e;
  return /* @__PURE__ */ i.createElement(st, { onClose: a, open: t, size: r, testId: O }, /* @__PURE__ */ i.createElement(Aa, { showCloseButton: d, onClose: a }, o), (n || y) && /* @__PURE__ */ i.createElement(ct, null, n && /* @__PURE__ */ i.createElement(X, null, n), y), /* @__PURE__ */ i.createElement(ut, { fixed: g }, e.showCancelButton && /* @__PURE__ */ i.createElement(xe, { variant: "plain", size: "medium", onClick: e.onClickCancel, disabled: e.disabledCancelButton }, e.cancelButtonLabel), /* @__PURE__ */ i.createElement(
    xe,
    {
      size: "medium",
      onClick: m,
      isLoading: u,
      disabled: f,
      variant: s
    },
    l
  )));
};
var Ua = "Image_3_1_3_o7q5j90";
const Ja = ({ src: e, alt: t }) => /* @__PURE__ */ i.createElement("img", { src: e, alt: t, className: Ua });
var Xa = "ModalWithImage_3_1_3_vq52ei0";
const Oi = ({
  open: e,
  onClose: t,
  size: a = "S",
  src: r,
  title: o,
  description: n,
  footerContentAlign: l = "center",
  footerContentDirection: s = "row",
  footerContent: u,
  children: f,
  testId: m
}) => /* @__PURE__ */ i.createElement(st, { onClose: t, open: e, size: a, testId: m, showOutsideCloseButton: !0 }, /* @__PURE__ */ i.createElement(Ja, { src: r }), /* @__PURE__ */ i.createElement(ct, null, /* @__PURE__ */ i.createElement("div", { className: Xa }, o && /* @__PURE__ */ i.createElement(Re, { size: "XXS", align: "center" }, o), n && /* @__PURE__ */ i.createElement("div", null, /* @__PURE__ */ i.createElement(X, { align: "center" }, n)), f)), /* @__PURE__ */ i.createElement(ut, { align: l, direction: s }, u));
var Ka = "Table_3_1_3_osozqi0", Va = "Table_3_1_3_osozqi3", Qa = "Table_3_1_3_osozqi2", Za = "Table_3_1_3_osozqi1";
const Di = ({ children: e, testId: t, ...a }) => /* @__PURE__ */ i.createElement("table", { "data-testid": t, className: Ka, ...a }, e), Li = ({ children: e, ...t }) => /* @__PURE__ */ i.createElement("thead", { className: Za, ...t }, e), Ri = ({ children: e, ...t }) => /* @__PURE__ */ i.createElement("tbody", { ...t }, e), Hi = ({ children: e, testId: t, ...a }) => /* @__PURE__ */ i.createElement("tr", { "data-testid": t, ...a }, e), Gi = ({ children: e, ...t }) => /* @__PURE__ */ i.createElement("th", { className: Qa, ...t }, e && /* @__PURE__ */ i.createElement(X, { weight: "bold", lineHeight: "tight" }, e)), Mi = ({ children: e, testId: t, ...a }) => /* @__PURE__ */ i.createElement("td", { "data-testid": t, className: Va, ...a }, e);
var ei = { center: "Stack_3_1_3_hhgw511", "flex-start": "Stack_3_1_3_hhgw512", "flex-end": "Stack_3_1_3_hhgw513", stretch: "Stack_3_1_3_hhgw514" }, ti = "Stack_3_1_3_hhgw510", ri = { row: "Stack_3_1_3_hhgw518", column: "Stack_3_1_3_hhgw519", "column-reverse": "Stack_3_1_3_hhgw51a" }, ai = { 100: "Stack_3_1_3_hhgw51b", 150: "Stack_3_1_3_hhgw51c", 200: "Stack_3_1_3_hhgw51d", 250: "Stack_3_1_3_hhgw51e", 300: "Stack_3_1_3_hhgw51f", 350: "Stack_3_1_3_hhgw51g", 400: "Stack_3_1_3_hhgw51h", 500: "Stack_3_1_3_hhgw51i", 600: "Stack_3_1_3_hhgw51j", 700: "Stack_3_1_3_hhgw51k", 800: "Stack_3_1_3_hhgw51l", 900: "Stack_3_1_3_hhgw51m", 1e3: "Stack_3_1_3_hhgw51n", 1200: "Stack_3_1_3_hhgw51o", 1400: "Stack_3_1_3_hhgw51p", 1600: "Stack_3_1_3_hhgw51q", 2e3: "Stack_3_1_3_hhgw51r", 2400: "Stack_3_1_3_hhgw51s", "050": "Stack_3_1_3_hhgw51t" }, ii = { center: "Stack_3_1_3_hhgw515", "flex-start": "Stack_3_1_3_hhgw516", "flex-end": "Stack_3_1_3_hhgw517" }, oi = { wrap: "Stack_3_1_3_hhgw51u", nowrap: "Stack_3_1_3_hhgw51v" };
const mt = ({
  align: e = "center",
  justify: t = "flex-start",
  direction: a = "row",
  spacing: r = "600",
  wrap: o = "wrap",
  testId: n,
  children: l
}) => /* @__PURE__ */ i.createElement(
  "div",
  {
    className: b(
      ti,
      ei[e],
      ii[t],
      ri[a],
      ai[r],
      oi[o]
    ),
    "data-testid": n
  },
  l
), Ai = (e) => /* @__PURE__ */ i.createElement(mt, { align: "flex-start", ...e, direction: "column" }, e.children), Ii = (e) => /* @__PURE__ */ i.createElement(mt, { align: "center", ...e, direction: "row" }, e.children);
var ni = "DefinitionList_3_1_3_sctea40";
const $i = ({ children: e, testId: t }) => /* @__PURE__ */ i.createElement("dl", { "data-testid": t, className: ni }, e), Yi = ({ children: e, testId: t }) => /* @__PURE__ */ i.createElement("dt", { "data-testid": t }, e), qi = ({ children: e, testId: t }) => /* @__PURE__ */ i.createElement("dd", { "data-testid": t }, e);
var li = "StatusLabel_3_1_3_mmfme30", si = { default: "StatusLabel_3_1_3_mmfme3z", danger: "StatusLabel_3_1_3_mmfme310", success: "StatusLabel_3_1_3_mmfme311", shepink: "StatusLabel_3_1_3_mmfme312", sheblue: "StatusLabel_3_1_3_mmfme313", shegreen: "StatusLabel_3_1_3_mmfme314", defaultLight: "StatusLabel_3_1_3_mmfme315", dangerLight: "StatusLabel_3_1_3_mmfme316", successLight: "StatusLabel_3_1_3_mmfme317", shepinkLight: "StatusLabel_3_1_3_mmfme318", sheblueLight: "StatusLabel_3_1_3_mmfme319", shegreenLight: "StatusLabel_3_1_3_mmfme31a" }, ci = { S: "StatusLabel_3_1_3_mmfme3v", M: "StatusLabel_3_1_3_mmfme3w", L: "StatusLabel_3_1_3_mmfme3x" }, ui = "StatusLabel_3_1_3_mmfme3y", mi = { default: "StatusLabel_3_1_3_mmfme34", danger: "StatusLabel_3_1_3_mmfme35", success: "StatusLabel_3_1_3_mmfme36", shepink: "StatusLabel_3_1_3_mmfme37", sheblue: "StatusLabel_3_1_3_mmfme38", shegreen: "StatusLabel_3_1_3_mmfme39", defaultLight: "StatusLabel_3_1_3_mmfme3a", dangerLight: "StatusLabel_3_1_3_mmfme3b", successLight: "StatusLabel_3_1_3_mmfme3c", shepinkLight: "StatusLabel_3_1_3_mmfme3d", sheblueLight: "StatusLabel_3_1_3_mmfme3e", shegreenLight: "StatusLabel_3_1_3_mmfme3f" }, pi = { S: "StatusLabel_3_1_3_mmfme31", M: "StatusLabel_3_1_3_mmfme32", L: "StatusLabel_3_1_3_mmfme33" }, fi = { "fit-content": "StatusLabel_3_1_3_mmfme31b" }, vi = { default: "StatusLabel_3_1_3_mmfme3j", danger: "StatusLabel_3_1_3_mmfme3k", success: "StatusLabel_3_1_3_mmfme3l", shepink: "StatusLabel_3_1_3_mmfme3m", sheblue: "StatusLabel_3_1_3_mmfme3n", shegreen: "StatusLabel_3_1_3_mmfme3o", defaultLight: "StatusLabel_3_1_3_mmfme3p", dangerLight: "StatusLabel_3_1_3_mmfme3q", successLight: "StatusLabel_3_1_3_mmfme3r", shepinkLight: "StatusLabel_3_1_3_mmfme3s", sheblueLight: "StatusLabel_3_1_3_mmfme3t", shegreenLight: "StatusLabel_3_1_3_mmfme3u" }, _i = { S: "StatusLabel_3_1_3_mmfme3g", M: "StatusLabel_3_1_3_mmfme3h", L: "StatusLabel_3_1_3_mmfme3i" };
const Wi = ({ children: e, size: t = "M", color: a = "default", icon: r, testId: o, width: n }) => /* @__PURE__ */ i.createElement(
  "div",
  {
    className: b(li, pi[t], mi[a], n && fi[n]),
    "data-testid": o
  },
  r && /* @__PURE__ */ i.createElement("span", { className: b(ui, ci[t], si[a]) }, r),
  /* @__PURE__ */ i.createElement("span", { className: b(_i[t], vi[a]) }, e)
);
var di = "Avatar_3_1_3_354w640", gi = "Avatar_3_1_3_354w641", bi = { XS: "Avatar_3_1_3_354w642", S: "Avatar_3_1_3_354w643", M: "Avatar_3_1_3_354w644", L: "Avatar_3_1_3_354w645", XL: "Avatar_3_1_3_354w646" };
const hi = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAMFBMVEXFxcX////CwsLGxsb7+/vT09PJycn19fXq6urb29vOzs7w8PDe3t7n5+f5+fnt7e2uCwolAAAFHUlEQVR4nO2dC5qqMAyFMTwUFNz/bq+VYYrKKJCkOfXmXwHna5uTpA+KwnEcx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3Ecx3EcA2iO9cdIc5PUdO2l78+BU39p66b4HplE3eU6VIcnqmNfl1+gksr6+iIucr50WYukor7+re6Hoe1y1UhNO3zUd+fUFRmKpOa0Tt6dY5ubRCouG/QFzk1WGmnt/JxzykcjdZ/jyxJDLlOV2l36AtcsJJb9boG3YcR3DuqODIE3LtYKPkDdmwRmpUToUaSaq++AvRgZMWbOubQW8hdCAm8ZDugoikzREdCJ2okJPBx6azFLNOwoOgcxojJ98JkaTSJxMpklKrCAKhZGI0drTY/wU5lXoJYibannV9NYy4oozNEAkPHTjop+DTDxVGkIgYJNoyQQJtiIW+EMjGAjm649AjGIaqswcEZQKJ2QPlJbqytki6ZXAAZRJ52J2McaUowzAfs+uFzrYhnzaapphiPWdaJWShqxjqa6kTTQ205TVbsfMa6htL0iYOsXpJrQjHSmCkv1QGPtiHqlYcQ21Gj7fcDU8xOEUuNgSltPzexh+HqFlanCBHZ4OLhCV+gK/3OF6vWvucLv98MUOY2pwu/PS/+D2qJU7pYGbOvDFDW+bbON9p3o3oRxn0bfLgZTgSn6pSfrtr56qLHemtHPTK2319SzGvtjQ9qeb39Wgc66Cm073nd0U1PzDdJCO3Gzn6TKpl9Zq7ujGWsQhlA3NwWIMwG9zM08Y/tBrR9VWeczv5CSQuuUNKIUTk23ZJ5RKfVhjnkXotfWIlgX2BSCDYbZR+QTcLhb3dKZDUY2M0d4KWItwhHRah/zsrOgKw4wycwjcgEVcgQDQo23CqSiWEJkFAfod2oE1uIZdA1OsCPqFXYNTjCfb8Ez+iX2x5sKLlVbhtqdDcar9ZevhnbZxoBUD35k23t0d304LYs1ELVbnfFaZ/REJJX9niP8Q19moZGo3m8XR/yBvOnjFftncI2c8ZuNo7WMP5HQh6yRGrlmFOJTnyTcT+zRlqPUBI2gTVWNUzUna1ERgecgF4GpNBQ38jGqxVLzQA1A31Rrhk6Yz9QEh/WND0GnuG9huhiTXJkxfAizTHLr6cbJKN6UCU6x/2DTRE1xEeEXi3O0ZUqBN4nJRzHhFB1JPlFTBZlI2kQ8zc3KJ1Le8DIRmFJiknuVS6RK4Ej/JtBfJErDSzOBiY4wJHX6Z1I4v1GUmdCPNirnLLeg3oJLcbX5PcpHNbRvOa1A956QmRPOUXVF+zkaUJynpkYR0bOMJH2nNej1pqyV/aKkz9jr5yj5vrXXz1F5SQLACiMapmierj2ikLyleKdlA/I/2oFxiglxx9B+mHwz0lf34IZQfhDRhlD6bhvgEAoPYooHkTczSIZTLC+cEExsoNKZiGBiY9cCfo/Y/SjIOBMQizWWTe73CMUasJx7jlD+DdKdWUKoY4PRYFtGpO0G1Lx4RaadgTtJhf4fiGqGIwKWCGuGIwKWqP+7IxYCzygjR9IAO5pC7Da9g70TBVpWRNgFBlgT8RV2WxHbKwJMv4BOaEaYaU2K16yZMN/qgV+G7IWIvwyZCxHeDQMsR8wg0DBDDXB5H2EV+hkEGmaoySHQsEJNFoGGFWrAq98JRhUMX1iMMMqLLEIpK5jCbd4vw9nSt/72lewXiN6jmdjfq8Hdknlk92ZwJnbIMMRM7JBhiFlUFoHd1UWaP1QKsPsHA5mkNB+Smn9r+138jGzYzgAAAABJRU5ErkJggg==", Ui = ({ src: e, size: t = "M", alt: a, testId: r }) => /* @__PURE__ */ i.createElement("div", { className: b(di, bi[t]), "data-testid": r }, /* @__PURE__ */ i.createElement("img", { className: gi, src: e || hi, alt: a }));
var yi = { M: "FormGroup_3_1_3_1p6s97x2", L: "FormGroup_3_1_3_1p6s97x3" }, Si = "FormGroup_3_1_3_1p6s97x0", ki = "FormGroup_3_1_3_1p6s97x1";
const Ji = ({ horizontal: e, children: t, testId: a, gapSize: r = "M" }) => {
  const o = e ? Si : ki;
  return /* @__PURE__ */ i.createElement("div", { className: b(o, yi[r]), "data-testid": a }, t);
};
export {
  ji as Alert,
  Ni as AlertContent,
  xi as AnchorButton,
  Ui as Avatar,
  X as BodyText,
  xe as Button,
  oa as Checkbox,
  Ti as CheckboxGroup,
  Na as CloseButton,
  qi as Dd,
  $i as Dl,
  Yi as Dt,
  Ji as FormGroup,
  Ii as HStack,
  Re as Heading,
  pr as Icon,
  Ja as Image,
  le as LabelText,
  Me as LabeledForm,
  Fi as Link,
  Ei as LinkButton,
  st as Modal,
  ct as ModalBody,
  Ma as ModalCloseButton,
  Fa as ModalContent,
  Ci as ModalDialog,
  ut as ModalFooter,
  Aa as ModalHeader,
  Oi as ModalWithImage,
  wa as Overlay,
  ga as Radio,
  zi as RadioGroup,
  wi as Select,
  mt as Stack,
  Wi as StatusLabel,
  Di as Table,
  Ri as Tbody,
  Mi as Td,
  wr as TextInput,
  Bi as TextInputGroup,
  Lr as Textarea,
  Gi as Th,
  Li as Thead,
  Pr as Tooltip,
  Hi as Tr,
  Ai as VStack
};
